// Generated from /DSL/DSL.Library/graph.g4 by ANTLR 4.13.1
// jshint ignore: start
import antlr4 from 'antlr4';
import graphListener from './graphListener.js';
import graphVisitor from './graphVisitor.js';

const serializedATN = [4,1,109,1103,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,
7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,
2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,2,
20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,26,2,27,
7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,33,7,33,2,34,7,
34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,39,2,40,7,40,2,41,7,41,
2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,45,2,46,7,46,2,47,7,47,2,48,7,48,2,
49,7,49,2,50,7,50,2,51,7,51,2,52,7,52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,
7,56,2,57,7,57,2,58,7,58,2,59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,63,7,
63,2,64,7,64,2,65,7,65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,7,70,
2,71,7,71,2,72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,77,2,
78,7,78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,7,84,2,85,
7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,2,91,7,91,2,92,7,
92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,1,0,3,0,196,8,0,1,0,1,0,1,0,1,
1,1,1,1,1,1,2,1,2,1,2,1,3,5,3,208,8,3,10,3,12,3,211,9,3,1,3,5,3,214,8,3,
10,3,12,3,217,9,3,1,3,1,3,3,3,221,8,3,1,3,1,3,3,3,225,8,3,1,3,1,3,1,3,1,
3,1,3,1,3,1,3,5,3,234,8,3,10,3,12,3,237,9,3,1,4,1,4,1,4,1,4,5,4,243,8,4,
10,4,12,4,246,9,4,1,4,1,4,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,3,5,258,8,5,1,
6,1,6,1,6,1,6,5,6,264,8,6,10,6,12,6,267,9,6,1,6,1,6,1,7,1,7,3,7,273,8,7,
1,7,1,7,1,7,1,7,1,7,3,7,280,8,7,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,
1,9,1,9,1,9,1,9,1,10,1,10,1,10,3,10,299,8,10,1,10,1,10,3,10,303,8,10,1,10,
1,10,1,11,1,11,1,11,1,11,1,11,1,11,1,11,5,11,314,8,11,10,11,12,11,317,9,
11,1,11,3,11,320,8,11,1,11,1,11,1,12,1,12,1,12,5,12,327,8,12,10,12,12,12,
330,9,12,3,12,332,8,12,1,12,3,12,335,8,12,1,12,1,12,5,12,339,8,12,10,12,
12,12,342,9,12,3,12,344,8,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,
1,13,1,13,1,13,5,13,358,8,13,10,13,12,13,361,9,13,3,13,363,8,13,1,13,3,13,
366,8,13,1,13,1,13,5,13,370,8,13,10,13,12,13,373,9,13,3,13,375,8,13,1,13,
1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,14,3,14,388,8,14,1,14,1,14,
1,14,1,14,1,14,1,14,1,14,1,14,1,14,3,14,399,8,14,1,14,1,14,1,14,1,14,1,14,
1,14,3,14,407,8,14,1,14,1,14,1,14,1,14,1,15,3,15,414,8,15,1,15,1,15,1,15,
1,15,3,15,420,8,15,1,15,1,15,1,15,1,16,3,16,426,8,16,1,16,3,16,429,8,16,
1,16,1,16,1,16,1,16,1,16,1,16,1,17,1,17,1,17,1,17,1,17,5,17,442,8,17,10,
17,12,17,445,9,17,1,17,1,17,1,17,1,17,3,17,451,8,17,1,17,1,17,5,17,455,8,
17,10,17,12,17,458,9,17,1,17,1,17,1,18,1,18,1,18,1,19,1,19,3,19,467,8,19,
1,19,1,19,3,19,471,8,19,1,19,3,19,474,8,19,1,19,3,19,477,8,19,1,20,1,20,
1,20,5,20,482,8,20,10,20,12,20,485,9,20,1,20,1,20,1,20,3,20,490,8,20,1,20,
1,20,1,20,3,20,495,8,20,1,20,1,20,1,21,1,21,1,21,4,21,502,8,21,11,21,12,
21,503,1,21,1,21,1,22,1,22,1,22,1,22,3,22,512,8,22,1,23,1,23,1,23,1,24,1,
24,1,24,5,24,520,8,24,10,24,12,24,523,9,24,1,24,1,24,1,25,1,25,1,25,1,25,
1,25,1,25,1,25,1,26,1,26,3,26,536,8,26,1,27,1,27,3,27,540,8,27,1,28,1,28,
1,28,1,28,1,29,1,29,1,29,1,29,3,29,550,8,29,1,29,1,29,3,29,554,8,29,1,29,
1,29,1,29,1,29,1,29,5,29,561,8,29,10,29,12,29,564,9,29,3,29,566,8,29,3,29,
568,8,29,1,30,1,30,1,31,1,31,1,31,1,32,1,32,5,32,577,8,32,10,32,12,32,580,
9,32,1,32,1,32,1,33,1,33,3,33,586,8,33,1,34,1,34,1,34,3,34,591,8,34,1,35,
1,35,1,36,1,36,1,36,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,3,37,607,
8,37,1,38,1,38,1,38,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,
39,1,39,3,39,624,8,39,1,40,1,40,1,40,1,40,1,40,5,40,631,8,40,10,40,12,40,
634,9,40,1,40,1,40,3,40,638,8,40,1,41,1,41,1,42,1,42,3,42,644,8,42,1,43,
1,43,1,43,3,43,649,8,43,1,43,1,43,3,43,653,8,43,1,44,1,44,1,44,1,45,1,45,
1,46,1,46,1,46,1,46,1,46,1,46,1,46,3,46,667,8,46,1,47,1,47,1,47,1,47,1,47,
1,47,1,47,1,47,1,48,1,48,1,48,1,49,1,49,1,49,3,49,683,8,49,1,49,5,49,686,
8,49,10,49,12,49,689,9,49,1,49,1,49,1,49,3,49,694,8,49,1,50,1,50,1,50,1,
51,1,51,1,51,1,51,1,51,1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,52,
3,52,714,8,52,1,53,1,53,1,53,1,53,1,53,1,53,3,53,722,8,53,1,53,1,53,1,53,
1,53,1,53,1,53,1,53,1,53,1,53,1,53,1,53,1,53,5,53,736,8,53,10,53,12,53,739,
9,53,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,
54,1,54,1,54,1,54,1,54,1,54,3,54,760,8,54,1,54,1,54,1,54,1,54,1,54,1,54,
5,54,768,8,54,10,54,12,54,771,9,54,3,54,773,8,54,1,54,1,54,1,54,3,54,778,
8,54,1,54,1,54,5,54,782,8,54,10,54,12,54,785,9,54,1,54,1,54,3,54,789,8,54,
1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,
54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,
1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,
54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,
3,54,849,8,54,1,54,1,54,1,54,1,54,5,54,855,8,54,10,54,12,54,858,9,54,1,55,
1,55,1,55,1,55,1,56,1,56,1,56,1,56,1,57,1,57,1,57,1,57,1,58,1,58,1,58,1,
58,1,59,1,59,1,59,1,59,1,60,1,60,1,60,1,60,1,61,1,61,1,61,3,61,887,8,61,
1,61,1,61,3,61,891,8,61,1,62,1,62,1,62,5,62,896,8,62,10,62,12,62,899,9,62,
1,63,1,63,1,63,5,63,904,8,63,10,63,12,63,907,9,63,1,64,1,64,1,65,1,65,1,
65,1,65,1,66,1,66,1,66,5,66,918,8,66,10,66,12,66,921,9,66,3,66,923,8,66,
1,67,1,67,1,67,1,67,1,67,3,67,930,8,67,1,68,1,68,1,68,1,68,1,68,3,68,937,
8,68,1,68,1,68,1,68,1,68,1,68,3,68,944,8,68,1,68,1,68,3,68,948,8,68,3,68,
950,8,68,3,68,952,8,68,1,69,1,69,1,70,1,70,1,71,1,71,1,72,1,72,1,73,1,73,
1,74,1,74,1,75,1,75,1,76,1,76,1,77,1,77,1,78,1,78,1,79,1,79,1,80,1,80,1,
81,1,81,1,82,1,82,1,83,1,83,1,84,1,84,1,85,1,85,1,86,1,86,1,87,1,87,1,87,
1,88,1,88,1,88,1,88,1,88,1,88,5,88,999,8,88,10,88,12,88,1002,9,88,1,89,1,
89,3,89,1006,8,89,1,90,1,90,1,91,1,91,1,91,1,91,1,91,1,91,1,91,1,91,1,91,
1,91,5,91,1020,8,91,10,91,12,91,1023,9,91,1,91,1,91,1,91,3,91,1028,8,91,
1,91,1,91,1,91,5,91,1033,8,91,10,91,12,91,1036,9,91,1,91,1,91,1,91,3,91,
1041,8,91,1,91,1,91,5,91,1045,8,91,10,91,12,91,1048,9,91,1,91,1,91,1,91,
3,91,1053,8,91,1,91,1,91,5,91,1057,8,91,10,91,12,91,1060,9,91,1,91,1,91,
1,91,3,91,1065,8,91,1,91,1,91,3,91,1069,8,91,1,91,1,91,5,91,1073,8,91,10,
91,12,91,1076,9,91,1,92,1,92,1,92,1,92,1,92,3,92,1083,8,92,1,93,1,93,3,93,
1087,8,93,1,93,1,93,1,94,1,94,1,94,1,94,1,94,1,94,1,94,1,95,1,95,1,95,1,
96,1,96,1,96,0,3,106,108,182,97,0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,
30,32,34,36,38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,
78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,
120,122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,152,154,
156,158,160,162,164,166,168,170,172,174,176,178,180,182,184,186,188,190,
192,0,8,2,0,2,3,104,104,1,0,4,6,1,0,2,3,2,0,81,82,99,100,1,0,97,98,2,0,1,
1,105,105,1,0,70,71,1,0,90,91,1170,0,195,1,0,0,0,2,200,1,0,0,0,4,203,1,0,
0,0,6,209,1,0,0,0,8,238,1,0,0,0,10,257,1,0,0,0,12,259,1,0,0,0,14,272,1,0,
0,0,16,281,1,0,0,0,18,291,1,0,0,0,20,295,1,0,0,0,22,306,1,0,0,0,24,323,1,
0,0,0,26,354,1,0,0,0,28,406,1,0,0,0,30,413,1,0,0,0,32,425,1,0,0,0,34,436,
1,0,0,0,36,461,1,0,0,0,38,464,1,0,0,0,40,478,1,0,0,0,42,501,1,0,0,0,44,507,
1,0,0,0,46,513,1,0,0,0,48,516,1,0,0,0,50,526,1,0,0,0,52,535,1,0,0,0,54,539,
1,0,0,0,56,541,1,0,0,0,58,545,1,0,0,0,60,569,1,0,0,0,62,571,1,0,0,0,64,574,
1,0,0,0,66,585,1,0,0,0,68,590,1,0,0,0,70,592,1,0,0,0,72,594,1,0,0,0,74,606,
1,0,0,0,76,608,1,0,0,0,78,623,1,0,0,0,80,637,1,0,0,0,82,639,1,0,0,0,84,641,
1,0,0,0,86,645,1,0,0,0,88,654,1,0,0,0,90,657,1,0,0,0,92,659,1,0,0,0,94,668,
1,0,0,0,96,676,1,0,0,0,98,693,1,0,0,0,100,695,1,0,0,0,102,698,1,0,0,0,104,
713,1,0,0,0,106,721,1,0,0,0,108,788,1,0,0,0,110,859,1,0,0,0,112,863,1,0,
0,0,114,867,1,0,0,0,116,871,1,0,0,0,118,875,1,0,0,0,120,879,1,0,0,0,122,
890,1,0,0,0,124,892,1,0,0,0,126,900,1,0,0,0,128,908,1,0,0,0,130,910,1,0,
0,0,132,922,1,0,0,0,134,924,1,0,0,0,136,951,1,0,0,0,138,953,1,0,0,0,140,
955,1,0,0,0,142,957,1,0,0,0,144,959,1,0,0,0,146,961,1,0,0,0,148,963,1,0,
0,0,150,965,1,0,0,0,152,967,1,0,0,0,154,969,1,0,0,0,156,971,1,0,0,0,158,
973,1,0,0,0,160,975,1,0,0,0,162,977,1,0,0,0,164,979,1,0,0,0,166,981,1,0,
0,0,168,983,1,0,0,0,170,985,1,0,0,0,172,987,1,0,0,0,174,989,1,0,0,0,176,
992,1,0,0,0,178,1005,1,0,0,0,180,1007,1,0,0,0,182,1064,1,0,0,0,184,1082,
1,0,0,0,186,1084,1,0,0,0,188,1090,1,0,0,0,190,1097,1,0,0,0,192,1100,1,0,
0,0,194,196,5,40,0,0,195,194,1,0,0,0,195,196,1,0,0,0,196,197,1,0,0,0,197,
198,3,6,3,0,198,199,5,0,0,1,199,1,1,0,0,0,200,201,3,136,68,0,201,202,5,0,
0,1,202,3,1,0,0,0,203,204,3,108,54,0,204,205,5,0,0,1,205,5,1,0,0,0,206,208,
3,18,9,0,207,206,1,0,0,0,208,211,1,0,0,0,209,207,1,0,0,0,209,210,1,0,0,0,
210,215,1,0,0,0,211,209,1,0,0,0,212,214,3,22,11,0,213,212,1,0,0,0,214,217,
1,0,0,0,215,213,1,0,0,0,215,216,1,0,0,0,216,220,1,0,0,0,217,215,1,0,0,0,
218,219,5,17,0,0,219,221,3,12,6,0,220,218,1,0,0,0,220,221,1,0,0,0,221,224,
1,0,0,0,222,223,5,58,0,0,223,225,3,8,4,0,224,222,1,0,0,0,224,225,1,0,0,0,
225,235,1,0,0,0,226,234,3,16,8,0,227,234,3,22,11,0,228,234,3,30,15,0,229,
234,3,28,14,0,230,234,3,32,16,0,231,234,3,26,13,0,232,234,3,20,10,0,233,
226,1,0,0,0,233,227,1,0,0,0,233,228,1,0,0,0,233,229,1,0,0,0,233,230,1,0,
0,0,233,231,1,0,0,0,233,232,1,0,0,0,234,237,1,0,0,0,235,233,1,0,0,0,235,
236,1,0,0,0,236,7,1,0,0,0,237,235,1,0,0,0,238,244,5,86,0,0,239,240,3,10,
5,0,240,241,3,180,90,0,241,243,1,0,0,0,242,239,1,0,0,0,243,246,1,0,0,0,244,
242,1,0,0,0,244,245,1,0,0,0,245,247,1,0,0,0,246,244,1,0,0,0,247,248,5,85,
0,0,248,9,1,0,0,0,249,250,3,158,79,0,250,251,5,89,0,0,251,252,3,108,54,0,
252,258,1,0,0,0,253,254,3,158,79,0,254,255,5,94,0,0,255,256,3,108,54,0,256,
258,1,0,0,0,257,249,1,0,0,0,257,253,1,0,0,0,258,11,1,0,0,0,259,265,5,86,
0,0,260,261,3,14,7,0,261,262,3,180,90,0,262,264,1,0,0,0,263,260,1,0,0,0,
264,267,1,0,0,0,265,263,1,0,0,0,265,266,1,0,0,0,266,268,1,0,0,0,267,265,
1,0,0,0,268,269,5,85,0,0,269,13,1,0,0,0,270,273,5,38,0,0,271,273,5,48,0,
0,272,270,1,0,0,0,272,271,1,0,0,0,272,273,1,0,0,0,273,274,1,0,0,0,274,275,
3,158,79,0,275,276,5,89,0,0,276,279,3,90,45,0,277,278,5,94,0,0,278,280,3,
108,54,0,279,277,1,0,0,0,279,280,1,0,0,0,280,15,1,0,0,0,281,282,5,28,0,0,
282,283,5,32,0,0,283,284,3,168,84,0,284,285,5,84,0,0,285,286,3,132,66,0,
286,287,5,83,0,0,287,288,5,89,0,0,288,289,3,90,45,0,289,290,5,90,0,0,290,
17,1,0,0,0,291,292,5,36,0,0,292,293,5,1,0,0,293,294,5,90,0,0,294,19,1,0,
0,0,295,296,5,66,0,0,296,298,5,105,0,0,297,299,3,138,69,0,298,297,1,0,0,
0,298,299,1,0,0,0,299,302,1,0,0,0,300,301,5,50,0,0,301,303,5,71,0,0,302,
300,1,0,0,0,302,303,1,0,0,0,303,304,1,0,0,0,304,305,3,62,31,0,305,21,1,0,
0,0,306,307,5,63,0,0,307,308,3,192,96,0,308,309,5,94,0,0,309,319,3,90,45,
0,310,311,5,8,0,0,311,315,5,86,0,0,312,314,3,24,12,0,313,312,1,0,0,0,314,
317,1,0,0,0,315,313,1,0,0,0,315,316,1,0,0,0,316,318,1,0,0,0,317,315,1,0,
0,0,318,320,5,85,0,0,319,310,1,0,0,0,319,320,1,0,0,0,320,321,1,0,0,0,321,
322,5,90,0,0,322,23,1,0,0,0,323,331,6,12,-1,0,324,327,5,106,0,0,325,327,
5,108,0,0,326,324,1,0,0,0,326,325,1,0,0,0,327,330,1,0,0,0,328,326,1,0,0,
0,328,329,1,0,0,0,329,332,1,0,0,0,330,328,1,0,0,0,331,328,1,0,0,0,331,332,
1,0,0,0,332,334,1,0,0,0,333,335,5,107,0,0,334,333,1,0,0,0,334,335,1,0,0,
0,335,343,1,0,0,0,336,339,5,106,0,0,337,339,5,108,0,0,338,336,1,0,0,0,338,
337,1,0,0,0,339,342,1,0,0,0,340,338,1,0,0,0,340,341,1,0,0,0,341,344,1,0,
0,0,342,340,1,0,0,0,343,340,1,0,0,0,343,344,1,0,0,0,344,345,1,0,0,0,345,
346,6,12,-1,0,346,347,3,170,85,0,347,348,5,84,0,0,348,349,3,132,66,0,349,
350,5,83,0,0,350,351,5,89,0,0,351,352,3,90,45,0,352,353,3,64,32,0,353,25,
1,0,0,0,354,362,6,13,-1,0,355,358,5,106,0,0,356,358,5,108,0,0,357,355,1,
0,0,0,357,356,1,0,0,0,358,361,1,0,0,0,359,357,1,0,0,0,359,360,1,0,0,0,360,
363,1,0,0,0,361,359,1,0,0,0,362,359,1,0,0,0,362,363,1,0,0,0,363,365,1,0,
0,0,364,366,5,107,0,0,365,364,1,0,0,0,365,366,1,0,0,0,366,374,1,0,0,0,367,
370,5,106,0,0,368,370,5,108,0,0,369,367,1,0,0,0,369,368,1,0,0,0,370,373,
1,0,0,0,371,369,1,0,0,0,371,372,1,0,0,0,372,375,1,0,0,0,373,371,1,0,0,0,
374,371,1,0,0,0,374,375,1,0,0,0,375,376,1,0,0,0,376,377,6,13,-1,0,377,378,
5,32,0,0,378,379,3,170,85,0,379,380,5,84,0,0,380,381,3,132,66,0,381,382,
5,83,0,0,382,383,5,89,0,0,383,384,3,90,45,0,384,385,3,64,32,0,385,27,1,0,
0,0,386,388,5,57,0,0,387,386,1,0,0,0,387,388,1,0,0,0,388,389,1,0,0,0,389,
390,5,11,0,0,390,391,3,142,71,0,391,392,5,84,0,0,392,393,3,132,66,0,393,
394,5,83,0,0,394,395,5,89,0,0,395,396,3,90,45,0,396,407,1,0,0,0,397,399,
5,10,0,0,398,397,1,0,0,0,398,399,1,0,0,0,399,400,1,0,0,0,400,401,5,11,0,
0,401,402,3,142,71,0,402,403,5,84,0,0,403,404,3,132,66,0,404,405,5,83,0,
0,405,407,1,0,0,0,406,387,1,0,0,0,406,398,1,0,0,0,407,408,1,0,0,0,408,409,
5,86,0,0,409,410,3,6,3,0,410,411,5,85,0,0,411,29,1,0,0,0,412,414,5,55,0,
0,413,412,1,0,0,0,413,414,1,0,0,0,414,415,1,0,0,0,415,416,5,42,0,0,416,417,
3,140,70,0,417,419,5,86,0,0,418,420,3,36,18,0,419,418,1,0,0,0,419,420,1,
0,0,0,420,421,1,0,0,0,421,422,3,38,19,0,422,423,5,85,0,0,423,31,1,0,0,0,
424,426,5,33,0,0,425,424,1,0,0,0,425,426,1,0,0,0,426,428,1,0,0,0,427,429,
5,49,0,0,428,427,1,0,0,0,428,429,1,0,0,0,429,430,1,0,0,0,430,431,5,21,0,
0,431,432,3,144,72,0,432,433,5,86,0,0,433,434,3,34,17,0,434,435,5,85,0,0,
435,33,1,0,0,0,436,437,5,15,0,0,437,443,5,86,0,0,438,439,3,54,27,0,439,440,
5,90,0,0,440,442,1,0,0,0,441,438,1,0,0,0,442,445,1,0,0,0,443,441,1,0,0,0,
443,444,1,0,0,0,444,446,1,0,0,0,445,443,1,0,0,0,446,456,5,85,0,0,447,448,
5,54,0,0,448,451,3,86,43,0,449,451,3,86,43,0,450,447,1,0,0,0,450,449,1,0,
0,0,451,452,1,0,0,0,452,453,5,90,0,0,453,455,1,0,0,0,454,450,1,0,0,0,455,
458,1,0,0,0,456,454,1,0,0,0,456,457,1,0,0,0,457,459,1,0,0,0,458,456,1,0,
0,0,459,460,3,38,19,0,460,35,1,0,0,0,461,462,5,14,0,0,462,463,5,1,0,0,463,
37,1,0,0,0,464,466,3,62,31,0,465,467,3,48,24,0,466,465,1,0,0,0,466,467,1,
0,0,0,467,470,1,0,0,0,468,469,5,49,0,0,469,471,3,62,31,0,470,468,1,0,0,0,
470,471,1,0,0,0,471,473,1,0,0,0,472,474,3,40,20,0,473,472,1,0,0,0,473,474,
1,0,0,0,474,476,1,0,0,0,475,477,3,46,23,0,476,475,1,0,0,0,476,477,1,0,0,
0,477,39,1,0,0,0,478,479,5,47,0,0,479,483,5,86,0,0,480,482,3,42,21,0,481,
480,1,0,0,0,482,485,1,0,0,0,483,481,1,0,0,0,483,484,1,0,0,0,484,489,1,0,
0,0,485,483,1,0,0,0,486,487,5,19,0,0,487,488,5,89,0,0,488,490,3,44,22,0,
489,486,1,0,0,0,489,490,1,0,0,0,490,494,1,0,0,0,491,492,5,21,0,0,492,493,
5,89,0,0,493,495,3,44,22,0,494,491,1,0,0,0,494,495,1,0,0,0,495,496,1,0,0,
0,496,497,5,85,0,0,497,41,1,0,0,0,498,499,3,146,73,0,499,500,5,89,0,0,500,
502,1,0,0,0,501,498,1,0,0,0,502,503,1,0,0,0,503,501,1,0,0,0,503,504,1,0,
0,0,504,505,1,0,0,0,505,506,3,44,22,0,506,43,1,0,0,0,507,511,3,62,31,0,508,
509,5,45,0,0,509,510,5,16,0,0,510,512,3,62,31,0,511,508,1,0,0,0,511,512,
1,0,0,0,512,45,1,0,0,0,513,514,5,46,0,0,514,515,3,64,32,0,515,47,1,0,0,0,
516,517,5,60,0,0,517,521,5,86,0,0,518,520,3,50,25,0,519,518,1,0,0,0,520,
523,1,0,0,0,521,519,1,0,0,0,521,522,1,0,0,0,522,524,1,0,0,0,523,521,1,0,
0,0,524,525,5,85,0,0,525,49,1,0,0,0,526,527,3,146,73,0,527,528,5,89,0,0,
528,529,5,34,0,0,529,530,3,140,70,0,530,531,3,52,26,0,531,532,5,90,0,0,532,
51,1,0,0,0,533,536,3,54,27,0,534,536,3,60,30,0,535,533,1,0,0,0,535,534,1,
0,0,0,536,53,1,0,0,0,537,540,3,58,29,0,538,540,3,56,28,0,539,537,1,0,0,0,
539,538,1,0,0,0,540,55,1,0,0,0,541,542,5,45,0,0,542,543,5,59,0,0,543,544,
3,172,86,0,544,57,1,0,0,0,545,546,5,45,0,0,546,549,3,108,54,0,547,548,5,
50,0,0,548,550,5,71,0,0,549,547,1,0,0,0,549,550,1,0,0,0,550,553,1,0,0,0,
551,552,5,66,0,0,552,554,5,16,0,0,553,551,1,0,0,0,553,554,1,0,0,0,554,567,
1,0,0,0,555,556,5,61,0,0,556,565,5,89,0,0,557,562,3,152,76,0,558,559,5,91,
0,0,559,561,3,152,76,0,560,558,1,0,0,0,561,564,1,0,0,0,562,560,1,0,0,0,562,
563,1,0,0,0,563,566,1,0,0,0,564,562,1,0,0,0,565,557,1,0,0,0,565,566,1,0,
0,0,566,568,1,0,0,0,567,555,1,0,0,0,567,568,1,0,0,0,568,59,1,0,0,0,569,570,
1,0,0,0,570,61,1,0,0,0,571,572,5,24,0,0,572,573,3,64,32,0,573,63,1,0,0,0,
574,578,5,86,0,0,575,577,3,66,33,0,576,575,1,0,0,0,577,580,1,0,0,0,578,576,
1,0,0,0,578,579,1,0,0,0,579,581,1,0,0,0,580,578,1,0,0,0,581,582,5,85,0,0,
582,65,1,0,0,0,583,586,3,68,34,0,584,586,3,64,32,0,585,583,1,0,0,0,585,584,
1,0,0,0,586,67,1,0,0,0,587,591,3,72,36,0,588,591,3,92,46,0,589,591,3,70,
35,0,590,587,1,0,0,0,590,588,1,0,0,0,590,589,1,0,0,0,591,69,1,0,0,0,592,
593,3,94,47,0,593,71,1,0,0,0,594,595,3,74,37,0,595,596,5,90,0,0,596,73,1,
0,0,0,597,607,3,96,48,0,598,607,3,100,50,0,599,607,3,102,51,0,600,607,3,
84,42,0,601,607,3,82,41,0,602,607,3,104,52,0,603,607,3,86,43,0,604,607,3,
76,38,0,605,607,3,108,54,0,606,597,1,0,0,0,606,598,1,0,0,0,606,599,1,0,0,
0,606,600,1,0,0,0,606,601,1,0,0,0,606,602,1,0,0,0,606,603,1,0,0,0,606,604,
1,0,0,0,606,605,1,0,0,0,607,75,1,0,0,0,608,609,5,41,0,0,609,610,3,108,54,
0,610,77,1,0,0,0,611,612,5,21,0,0,612,613,5,27,0,0,613,624,3,80,40,0,614,
615,5,21,0,0,615,616,5,23,0,0,616,624,3,80,40,0,617,618,5,21,0,0,618,619,
5,52,0,0,619,624,3,80,40,0,620,621,5,21,0,0,621,622,5,7,0,0,622,624,3,108,
54,0,623,611,1,0,0,0,623,614,1,0,0,0,623,617,1,0,0,0,623,620,1,0,0,0,624,
79,1,0,0,0,625,638,3,144,72,0,626,627,5,86,0,0,627,632,3,144,72,0,628,629,
5,91,0,0,629,631,3,144,72,0,630,628,1,0,0,0,631,634,1,0,0,0,632,630,1,0,
0,0,632,633,1,0,0,0,633,635,1,0,0,0,634,632,1,0,0,0,635,636,5,85,0,0,636,
638,1,0,0,0,637,625,1,0,0,0,637,626,1,0,0,0,638,81,1,0,0,0,639,640,5,29,
0,0,640,83,1,0,0,0,641,643,5,51,0,0,642,644,3,108,54,0,643,642,1,0,0,0,643,
644,1,0,0,0,644,85,1,0,0,0,645,648,3,88,44,0,646,647,5,89,0,0,647,649,3,
90,45,0,648,646,1,0,0,0,648,649,1,0,0,0,649,652,1,0,0,0,650,651,5,94,0,0,
651,653,3,108,54,0,652,650,1,0,0,0,652,653,1,0,0,0,653,87,1,0,0,0,654,655,
5,64,0,0,655,656,3,158,79,0,656,89,1,0,0,0,657,658,3,176,88,0,658,91,1,0,
0,0,659,660,5,35,0,0,660,661,5,84,0,0,661,662,3,108,54,0,662,663,5,83,0,
0,663,666,3,66,33,0,664,665,5,26,0,0,665,667,3,66,33,0,666,664,1,0,0,0,666,
667,1,0,0,0,667,93,1,0,0,0,668,669,5,31,0,0,669,670,5,84,0,0,670,671,3,88,
44,0,671,672,5,37,0,0,672,673,3,108,54,0,673,674,5,83,0,0,674,675,3,66,33,
0,675,95,1,0,0,0,676,677,5,65,0,0,677,678,3,98,49,0,678,97,1,0,0,0,679,680,
5,86,0,0,680,687,3,146,73,0,681,683,5,91,0,0,682,681,1,0,0,0,682,683,1,0,
0,0,683,684,1,0,0,0,684,686,3,146,73,0,685,682,1,0,0,0,686,689,1,0,0,0,687,
685,1,0,0,0,687,688,1,0,0,0,688,690,1,0,0,0,689,687,1,0,0,0,690,691,5,85,
0,0,691,694,1,0,0,0,692,694,5,4,0,0,693,679,1,0,0,0,693,692,1,0,0,0,694,
99,1,0,0,0,695,696,5,34,0,0,696,697,3,146,73,0,697,101,1,0,0,0,698,699,5,
53,0,0,699,700,3,106,53,0,700,701,5,94,0,0,701,702,3,108,54,0,702,103,1,
0,0,0,703,704,5,53,0,0,704,705,3,106,53,0,705,706,5,95,0,0,706,707,3,108,
54,0,707,714,1,0,0,0,708,709,5,53,0,0,709,710,3,106,53,0,710,711,5,96,0,
0,711,712,3,108,54,0,712,714,1,0,0,0,713,703,1,0,0,0,713,708,1,0,0,0,714,
105,1,0,0,0,715,716,6,53,-1,0,716,717,5,84,0,0,717,718,3,106,53,0,718,719,
5,83,0,0,719,722,1,0,0,0,720,722,3,136,68,0,721,715,1,0,0,0,721,720,1,0,
0,0,722,737,1,0,0,0,723,724,10,3,0,0,724,725,5,93,0,0,725,736,3,150,75,0,
726,727,10,2,0,0,727,728,5,80,0,0,728,729,5,71,0,0,729,736,5,79,0,0,730,
731,10,1,0,0,731,732,5,80,0,0,732,733,3,108,54,0,733,734,5,79,0,0,734,736,
1,0,0,0,735,723,1,0,0,0,735,726,1,0,0,0,735,730,1,0,0,0,736,739,1,0,0,0,
737,735,1,0,0,0,737,738,1,0,0,0,738,107,1,0,0,0,739,737,1,0,0,0,740,741,
6,54,-1,0,741,789,3,112,56,0,742,789,3,118,59,0,743,789,3,114,57,0,744,789,
5,72,0,0,745,789,3,116,58,0,746,789,3,172,86,0,747,789,5,1,0,0,748,749,5,
84,0,0,749,750,3,108,54,0,750,751,5,83,0,0,751,789,1,0,0,0,752,789,3,136,
68,0,753,789,3,78,39,0,754,755,7,0,0,0,755,789,3,108,54,15,756,757,3,136,
68,0,757,759,5,39,0,0,758,760,5,43,0,0,759,758,1,0,0,0,759,760,1,0,0,0,760,
761,1,0,0,0,761,762,5,20,0,0,762,789,1,0,0,0,763,772,5,86,0,0,764,769,3,
110,55,0,765,766,5,91,0,0,766,768,3,110,55,0,767,765,1,0,0,0,768,771,1,0,
0,0,769,767,1,0,0,0,769,770,1,0,0,0,770,773,1,0,0,0,771,769,1,0,0,0,772,
764,1,0,0,0,772,773,1,0,0,0,773,774,1,0,0,0,774,789,5,85,0,0,775,777,5,80,
0,0,776,778,3,108,54,0,777,776,1,0,0,0,777,778,1,0,0,0,778,783,1,0,0,0,779,
780,5,91,0,0,780,782,3,108,54,0,781,779,1,0,0,0,782,785,1,0,0,0,783,781,
1,0,0,0,783,784,1,0,0,0,784,786,1,0,0,0,785,783,1,0,0,0,786,789,5,79,0,0,
787,789,5,78,0,0,788,740,1,0,0,0,788,742,1,0,0,0,788,743,1,0,0,0,788,744,
1,0,0,0,788,745,1,0,0,0,788,746,1,0,0,0,788,747,1,0,0,0,788,748,1,0,0,0,
788,752,1,0,0,0,788,753,1,0,0,0,788,754,1,0,0,0,788,756,1,0,0,0,788,763,
1,0,0,0,788,775,1,0,0,0,788,787,1,0,0,0,789,856,1,0,0,0,790,791,10,12,0,
0,791,792,7,1,0,0,792,855,3,108,54,13,793,794,10,11,0,0,794,795,7,2,0,0,
795,855,3,108,54,12,796,797,10,10,0,0,797,798,7,3,0,0,798,855,3,108,54,11,
799,800,10,9,0,0,800,801,7,4,0,0,801,855,3,108,54,10,802,803,10,8,0,0,803,
804,5,103,0,0,804,855,3,108,54,9,805,806,10,7,0,0,806,807,5,101,0,0,807,
855,3,108,54,8,808,809,10,6,0,0,809,810,5,92,0,0,810,811,5,92,0,0,811,855,
3,108,54,7,812,813,10,5,0,0,813,814,5,92,0,0,814,815,3,108,54,0,815,816,
5,89,0,0,816,817,3,108,54,5,817,855,1,0,0,0,818,819,10,23,0,0,819,820,5,
93,0,0,820,855,3,150,75,0,821,822,10,22,0,0,822,823,5,92,0,0,823,824,5,93,
0,0,824,855,3,150,75,0,825,826,10,21,0,0,826,827,5,93,0,0,827,828,3,150,
75,0,828,829,3,120,60,0,829,855,1,0,0,0,830,831,10,20,0,0,831,832,5,92,0,
0,832,833,5,93,0,0,833,834,3,150,75,0,834,835,3,120,60,0,835,855,1,0,0,0,
836,837,10,19,0,0,837,838,5,80,0,0,838,839,5,71,0,0,839,855,5,79,0,0,840,
841,10,18,0,0,841,842,5,80,0,0,842,843,3,108,54,0,843,844,5,79,0,0,844,855,
1,0,0,0,845,846,10,14,0,0,846,848,5,39,0,0,847,849,5,43,0,0,848,847,1,0,
0,0,848,849,1,0,0,0,849,850,1,0,0,0,850,855,5,78,0,0,851,852,10,1,0,0,852,
853,5,9,0,0,853,855,3,90,45,0,854,790,1,0,0,0,854,793,1,0,0,0,854,796,1,
0,0,0,854,799,1,0,0,0,854,802,1,0,0,0,854,805,1,0,0,0,854,808,1,0,0,0,854,
812,1,0,0,0,854,818,1,0,0,0,854,821,1,0,0,0,854,825,1,0,0,0,854,830,1,0,
0,0,854,836,1,0,0,0,854,840,1,0,0,0,854,845,1,0,0,0,854,851,1,0,0,0,855,
858,1,0,0,0,856,854,1,0,0,0,856,857,1,0,0,0,857,109,1,0,0,0,858,856,1,0,
0,0,859,860,3,164,82,0,860,861,5,89,0,0,861,862,3,108,54,0,862,111,1,0,0,
0,863,864,5,28,0,0,864,865,3,168,84,0,865,866,3,120,60,0,866,113,1,0,0,0,
867,868,5,12,0,0,868,869,3,142,71,0,869,870,3,120,60,0,870,115,1,0,0,0,871,
872,5,67,0,0,872,873,3,192,96,0,873,874,3,120,60,0,874,117,1,0,0,0,875,876,
5,68,0,0,876,877,3,166,83,0,877,878,3,120,60,0,878,119,1,0,0,0,879,880,5,
84,0,0,880,881,3,122,61,0,881,882,5,83,0,0,882,121,1,0,0,0,883,886,3,126,
63,0,884,885,5,91,0,0,885,887,3,124,62,0,886,884,1,0,0,0,886,887,1,0,0,0,
887,891,1,0,0,0,888,891,3,124,62,0,889,891,1,0,0,0,890,883,1,0,0,0,890,888,
1,0,0,0,890,889,1,0,0,0,891,123,1,0,0,0,892,897,3,130,65,0,893,894,5,91,
0,0,894,896,3,130,65,0,895,893,1,0,0,0,896,899,1,0,0,0,897,895,1,0,0,0,897,
898,1,0,0,0,898,125,1,0,0,0,899,897,1,0,0,0,900,905,3,128,64,0,901,902,5,
91,0,0,902,904,3,128,64,0,903,901,1,0,0,0,904,907,1,0,0,0,905,903,1,0,0,
0,905,906,1,0,0,0,906,127,1,0,0,0,907,905,1,0,0,0,908,909,3,108,54,0,909,
129,1,0,0,0,910,911,3,160,80,0,911,912,5,89,0,0,912,913,3,108,54,0,913,131,
1,0,0,0,914,919,3,134,67,0,915,916,5,91,0,0,916,918,3,134,67,0,917,915,1,
0,0,0,918,921,1,0,0,0,919,917,1,0,0,0,919,920,1,0,0,0,920,923,1,0,0,0,921,
919,1,0,0,0,922,914,1,0,0,0,922,923,1,0,0,0,923,133,1,0,0,0,924,925,3,162,
81,0,925,926,5,89,0,0,926,929,3,90,45,0,927,928,5,94,0,0,928,930,3,108,54,
0,929,927,1,0,0,0,929,930,1,0,0,0,930,135,1,0,0,0,931,932,5,68,0,0,932,952,
3,148,74,0,933,952,3,148,74,0,934,936,5,69,0,0,935,937,3,148,74,0,936,935,
1,0,0,0,936,937,1,0,0,0,937,952,1,0,0,0,938,949,5,21,0,0,939,940,5,93,0,
0,940,943,3,144,72,0,941,942,5,93,0,0,942,944,5,54,0,0,943,941,1,0,0,0,943,
944,1,0,0,0,944,947,1,0,0,0,945,946,5,93,0,0,946,948,3,148,74,0,947,945,
1,0,0,0,947,948,1,0,0,0,948,950,1,0,0,0,949,939,1,0,0,0,949,950,1,0,0,0,
950,952,1,0,0,0,951,931,1,0,0,0,951,933,1,0,0,0,951,934,1,0,0,0,951,938,
1,0,0,0,952,137,1,0,0,0,953,954,5,105,0,0,954,139,1,0,0,0,955,956,5,105,
0,0,956,141,1,0,0,0,957,958,5,105,0,0,958,143,1,0,0,0,959,960,5,105,0,0,
960,145,1,0,0,0,961,962,5,105,0,0,962,147,1,0,0,0,963,964,5,105,0,0,964,
149,1,0,0,0,965,966,5,105,0,0,966,151,1,0,0,0,967,968,5,105,0,0,968,153,
1,0,0,0,969,970,5,105,0,0,970,155,1,0,0,0,971,972,5,105,0,0,972,157,1,0,
0,0,973,974,5,105,0,0,974,159,1,0,0,0,975,976,5,105,0,0,976,161,1,0,0,0,
977,978,5,105,0,0,978,163,1,0,0,0,979,980,7,5,0,0,980,165,1,0,0,0,981,982,
5,105,0,0,982,167,1,0,0,0,983,984,5,105,0,0,984,169,1,0,0,0,985,986,5,105,
0,0,986,171,1,0,0,0,987,988,7,6,0,0,988,173,1,0,0,0,989,990,3,176,88,0,990,
991,5,0,0,1,991,175,1,0,0,0,992,993,3,182,91,0,993,1000,3,178,89,0,994,995,
5,102,0,0,995,996,3,182,91,0,996,997,3,178,89,0,997,999,1,0,0,0,998,994,
1,0,0,0,999,1002,1,0,0,0,1000,998,1,0,0,0,1000,1001,1,0,0,0,1001,177,1,0,
0,0,1002,1000,1,0,0,0,1003,1006,5,92,0,0,1004,1006,1,0,0,0,1005,1003,1,0,
0,0,1005,1004,1,0,0,0,1006,179,1,0,0,0,1007,1008,7,7,0,0,1008,181,1,0,0,
0,1009,1010,6,91,-1,0,1010,1011,5,84,0,0,1011,1012,3,176,88,0,1012,1013,
5,83,0,0,1013,1065,1,0,0,0,1014,1065,3,184,92,0,1015,1021,5,86,0,0,1016,
1017,3,186,93,0,1017,1018,3,180,90,0,1018,1020,1,0,0,0,1019,1016,1,0,0,0,
1020,1023,1,0,0,0,1021,1019,1,0,0,0,1021,1022,1,0,0,0,1022,1027,1,0,0,0,
1023,1021,1,0,0,0,1024,1025,3,188,94,0,1025,1026,3,180,90,0,1026,1028,1,
0,0,0,1027,1024,1,0,0,0,1027,1028,1,0,0,0,1028,1034,1,0,0,0,1029,1030,3,
186,93,0,1030,1031,3,180,90,0,1031,1033,1,0,0,0,1032,1029,1,0,0,0,1033,1036,
1,0,0,0,1034,1032,1,0,0,0,1034,1035,1,0,0,0,1035,1037,1,0,0,0,1036,1034,
1,0,0,0,1037,1065,5,85,0,0,1038,1040,5,80,0,0,1039,1041,3,176,88,0,1040,
1039,1,0,0,0,1040,1041,1,0,0,0,1041,1046,1,0,0,0,1042,1043,5,91,0,0,1043,
1045,3,176,88,0,1044,1042,1,0,0,0,1045,1048,1,0,0,0,1046,1044,1,0,0,0,1046,
1047,1,0,0,0,1047,1049,1,0,0,0,1048,1046,1,0,0,0,1049,1065,5,79,0,0,1050,
1052,5,82,0,0,1051,1053,3,176,88,0,1052,1051,1,0,0,0,1052,1053,1,0,0,0,1053,
1058,1,0,0,0,1054,1055,5,102,0,0,1055,1057,3,176,88,0,1056,1054,1,0,0,0,
1057,1060,1,0,0,0,1058,1056,1,0,0,0,1058,1059,1,0,0,0,1059,1061,1,0,0,0,
1060,1058,1,0,0,0,1061,1065,5,81,0,0,1062,1065,5,1,0,0,1063,1065,3,192,96,
0,1064,1009,1,0,0,0,1064,1014,1,0,0,0,1064,1015,1,0,0,0,1064,1038,1,0,0,
0,1064,1050,1,0,0,0,1064,1062,1,0,0,0,1064,1063,1,0,0,0,1065,1074,1,0,0,
0,1066,1068,10,5,0,0,1067,1069,5,92,0,0,1068,1067,1,0,0,0,1068,1069,1,0,
0,0,1069,1070,1,0,0,0,1070,1071,5,80,0,0,1071,1073,5,79,0,0,1072,1066,1,
0,0,0,1073,1076,1,0,0,0,1074,1072,1,0,0,0,1074,1075,1,0,0,0,1075,183,1,0,
0,0,1076,1074,1,0,0,0,1077,1083,5,77,0,0,1078,1083,5,74,0,0,1079,1083,5,
75,0,0,1080,1083,5,76,0,0,1081,1083,5,73,0,0,1082,1077,1,0,0,0,1082,1078,
1,0,0,0,1082,1079,1,0,0,0,1082,1080,1,0,0,0,1082,1081,1,0,0,0,1083,185,1,
0,0,0,1084,1086,3,164,82,0,1085,1087,5,92,0,0,1086,1085,1,0,0,0,1086,1087,
1,0,0,0,1087,1088,1,0,0,0,1088,1089,3,190,95,0,1089,187,1,0,0,0,1090,1091,
5,80,0,0,1091,1092,5,105,0,0,1092,1093,5,89,0,0,1093,1094,5,76,0,0,1094,
1095,5,79,0,0,1095,1096,3,190,95,0,1096,189,1,0,0,0,1097,1098,5,89,0,0,1098,
1099,3,176,88,0,1099,191,1,0,0,0,1100,1101,5,105,0,0,1101,193,1,0,0,0,110,
195,209,215,220,224,233,235,244,257,265,272,279,298,302,315,319,326,328,
331,334,338,340,343,357,359,362,365,369,371,374,387,398,406,413,419,425,
428,443,450,456,466,470,473,476,483,489,494,503,511,521,535,539,549,553,
562,565,567,578,585,590,606,623,632,637,643,648,652,666,682,687,693,713,
721,735,737,759,769,772,777,783,788,848,854,856,886,890,897,905,919,922,
929,936,943,947,949,951,1000,1005,1021,1027,1034,1040,1046,1052,1058,1064,
1068,1074,1082,1086];


const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.dfa.DFA(ds, index) );

const sharedContextCache = new antlr4.atn.PredictionContextCache();

export default class graphParser extends antlr4.Parser {

    static grammarFileName = "graph.g4";
    static literalNames = [ null, null, "'+'", "'-'", "'*'", "'/'", "'%'", 
                            "'apply'", "'with'", "'as'", "'async'", "'block'", 
                            "'blockcall'", "'catch'", "'comment'", "'conditions'", 
                            "'confident'", "'context'", "'cow'", "'default'", 
                            "'defined'", "'digression'", "'digressions'", 
                            "'disable'", "'do'", "'done'", "'else'", "'enable'", 
                            "'external'", "'exit'", "'finally'", "'for'", 
                            "'function'", "'global'", "'goto'", "'if'", 
                            "'import'", "'in'", "'input'", "'is'", "'library'", 
                            "'logexpr'", "'node'", "'not'", "'of'", "'on'", 
                            "'ondigreturn'", "'onexit'", "'output'", "'preprocessor'", 
                            "'priority'", "'return'", "'save'", "'set'", 
                            "'shared'", "'start'", "'static'", "'sync'", 
                            "'system'", "'timeout'", "'transitions'", "'tags'", 
                            "'try'", "'type'", "'var'", "'wait'", "'when'", 
                            "'fill'", "'#'", "'$'", null, null, null, "'empty'", 
                            "'number'", "'boolean'", "'string'", "'unknown'", 
                            "'null'", "']'", "'['", "'>'", "'<'", "')'", 
                            "'('", "'}'", "'{'", "'\"'", "'`'", "':'", "';'", 
                            "','", "'?'", "'.'", "'='", "'+='", "'-='", 
                            "'=='", "'!='", "'>='", "'<='", null, "'|'" ];
    static symbolicNames = [ null, "StringLiteral", "PLUS", "MINUS", "STAR", 
                             "SLASH", "PERCENT", "APPLY", "WITH", "AS", 
                             "ASYNC", "BLOCK", "BLOCKCALL", "CATCH", "COMMENT", 
                             "CONDITIONS", "CONFIDENT", "CONTEXT", "COW", 
                             "DEFAULT", "DEFINED", "DIGRESSION", "DIGRESSIONS", 
                             "DISABLE", "DO", "DONE", "ELSE", "ENABLE", 
                             "EXTERNAL", "EXIT", "FINALLY", "FOR", "FUNCTION", 
                             "GLOBAL", "GOTO", "IF", "IMPORT", "IN", "INPUT", 
                             "IS", "LIBRARY", "LOGEXPR", "NODE", "NOT", 
                             "OF", "ON", "ONDIGRETURN", "ONEXIT", "OUTPUT", 
                             "PREPROCESSOR", "PRIORITY", "RETURN", "SAVE", 
                             "SET", "SHARED", "START", "STATIC", "SYNC", 
                             "SYSTEM", "TIMEOUT", "TRANSITIONS", "TAGS", 
                             "TRY", "TYPE", "VAR", "WAIT", "WHEN", "FILL", 
                             "BuiltinMark", "ContextMark", "DecimalLiteral", 
                             "DecimalIntegerLiteral", "BooleanLiteral", 
                             "Empty", "Number", "Boolean", "String", "Unknown", 
                             "NULL", "RBRACKET", "LBRACKET", "RANGLE", "LANGLE", 
                             "RPAREN", "LPAREN", "RCURL", "LCURL", "QUOTE", 
                             "BACKTRICK", "COLON", "SEMICOLON", "COMMA", 
                             "QMARK", "PERIOD", "EQUALSIGN", "AddOp", "RemoveOp", 
                             "EqualOp", "NotEqualOp", "GreaterEqualOp", 
                             "LessEqualOp", "OrOp", "TypeOr", "AndOp", "NotOperator", 
                             "ID", "LineComment", "DocsComment", "BlockComment", 
                             "Whitespace" ];
    static ruleNames = [ "file", "referenceFile", "expressionFile", "blockContent", 
                         "systemDescription", "systemElementDescription", 
                         "contextDescription", "contextElementDescription", 
                         "externalFunctionDeclaration", "importDefinition", 
                         "whenDescription", "typeDefinition", "functionDescription", 
                         "contextFunctionDescription", "blockDeclaration", 
                         "nodeDeclaration", "digressionDeclaration", "digressionContent", 
                         "comment", "nodeContent", "nodeOnExitSection", 
                         "nodeOnExitSectionItem", "onExitDoWithConfident", 
                         "nodeOnDigressionReturnSection", "nodeTransitionSection", 
                         "namedTransitionDefinition", "transitionDefinition", 
                         "transitionDefinitionOnMessage", "timeoutTransitionDefinition", 
                         "conditionalTransitionDefinition", "unconditionalTransitionDefinition", 
                         "doSection", "blockBody", "oneOrGroupedCommand", 
                         "nodeCommand", "cycleCommand", "statement", "statementBody", 
                         "logExpressionTypeCommand", "digressionControl", 
                         "digressionSpec", "exitCommand", "returnCommand", 
                         "variableDefinition", "variableDeclaration", "typeDescription", 
                         "conditionalCommand", "foreachCommand", "waitCommand", 
                         "activatedTransitionList", "gotoCommand", "setCommand", 
                         "assignOpCommand", "lValue", "expression", "objectPropertyExpressionPart", 
                         "externalFunctionCall", "blockFunctionCall", "slotFillingCall", 
                         "builtinFunctionCall", "argumentInvokation", "argumentList", 
                         "namedArgumentList", "positionalArgumentList", 
                         "positionalArgument", "namedArgument", "parameterList", 
                         "parameter", "reference", "whenId", "nodeId", "blockId", 
                         "digressionId", "transitionName", "referenceName", 
                         "memberName", "tagName", "factName", "fieldName", 
                         "variableName", "argumentName", "parameterName", 
                         "propertyName", "builtinFunctionName", "externalFunctionName", 
                         "functionName", "anyNumber", "typeEof", "type_", 
                         "questionMarkOptional", "objectTypeElementSeparator", 
                         "nonNullableType", "predefinedType", "propertySignature", 
                         "indexSignature", "typeAnnotation", "typeAlias" ];

    constructor(input) {
        super(input);
        this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
        this.ruleNames = graphParser.ruleNames;
        this.literalNames = graphParser.literalNames;
        this.symbolicNames = graphParser.symbolicNames;
    }

    sempred(localctx, ruleIndex, predIndex) {
    	switch(ruleIndex) {
    	case 53:
    	    		return this.lValue_sempred(localctx, predIndex);
    	case 54:
    	    		return this.expression_sempred(localctx, predIndex);
    	case 91:
    	    		return this.nonNullableType_sempred(localctx, predIndex);
        default:
            throw "No predicate with index:" + ruleIndex;
       }
    }

    lValue_sempred(localctx, predIndex) {
    	switch(predIndex) {
    		case 0:
    			return this.precpred(this._ctx, 3);
    		case 1:
    			return this.precpred(this._ctx, 2);
    		case 2:
    			return this.precpred(this._ctx, 1);
    		default:
    			throw "No predicate with index:" + predIndex;
    	}
    };

    expression_sempred(localctx, predIndex) {
    	switch(predIndex) {
    		case 3:
    			return this.precpred(this._ctx, 12);
    		case 4:
    			return this.precpred(this._ctx, 11);
    		case 5:
    			return this.precpred(this._ctx, 10);
    		case 6:
    			return this.precpred(this._ctx, 9);
    		case 7:
    			return this.precpred(this._ctx, 8);
    		case 8:
    			return this.precpred(this._ctx, 7);
    		case 9:
    			return this.precpred(this._ctx, 6);
    		case 10:
    			return this.precpred(this._ctx, 5);
    		case 11:
    			return this.precpred(this._ctx, 23);
    		case 12:
    			return this.precpred(this._ctx, 22);
    		case 13:
    			return this.precpred(this._ctx, 21);
    		case 14:
    			return this.precpred(this._ctx, 20);
    		case 15:
    			return this.precpred(this._ctx, 19);
    		case 16:
    			return this.precpred(this._ctx, 18);
    		case 17:
    			return this.precpred(this._ctx, 14);
    		case 18:
    			return this.precpred(this._ctx, 1);
    		default:
    			throw "No predicate with index:" + predIndex;
    	}
    };

    nonNullableType_sempred(localctx, predIndex) {
    	switch(predIndex) {
    		case 19:
    			return this.precpred(this._ctx, 5);
    		default:
    			throw "No predicate with index:" + predIndex;
    	}
    };




	file() {
	    let localctx = new FileContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 0, graphParser.RULE_file);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 195;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===40) {
	            this.state = 194;
	            this.match(graphParser.LIBRARY);
	        }

	        this.state = 197;
	        localctx.mainBlock = this.blockContent();
	        this.state = 198;
	        this.match(graphParser.EOF);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	referenceFile() {
	    let localctx = new ReferenceFileContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 2, graphParser.RULE_referenceFile);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 200;
	        this.reference();
	        this.state = 201;
	        this.match(graphParser.EOF);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	expressionFile() {
	    let localctx = new ExpressionFileContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 4, graphParser.RULE_expressionFile);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 203;
	        this.expression(0);
	        this.state = 204;
	        this.match(graphParser.EOF);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	blockContent() {
	    let localctx = new BlockContentContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 6, graphParser.RULE_blockContent);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 209;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===36) {
	            this.state = 206;
	            localctx._importDefinition = this.importDefinition();
	            localctx.imports.push(localctx._importDefinition);
	            this.state = 211;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	        this.state = 215;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,2,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                this.state = 212;
	                localctx._typeDefinition = this.typeDefinition();
	                localctx.types.push(localctx._typeDefinition); 
	            }
	            this.state = 217;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,2,this._ctx);
	        }

	        this.state = 220;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===17) {
	            this.state = 218;
	            this.match(graphParser.CONTEXT);
	            this.state = 219;
	            localctx.contextType = this.contextDescription();
	        }

	        this.state = 224;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===58) {
	            this.state = 222;
	            this.match(graphParser.SYSTEM);
	            this.state = 223;
	            localctx.system = this.systemDescription();
	        }

	        this.state = 235;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(((((_la - 10)) & ~0x1f) === 0 && ((1 << (_la - 10)) & 12847107) !== 0) || ((((_la - 42)) & ~0x1f) === 0 && ((1 << (_la - 42)) & 18915457) !== 0) || ((((_la - 106)) & ~0x1f) === 0 && ((1 << (_la - 106)) & 7) !== 0)) {
	            this.state = 233;
	            this._errHandler.sync(this);
	            switch(this._input.LA(1)) {
	            case 28:
	                this.state = 226;
	                localctx._externalFunctionDeclaration = this.externalFunctionDeclaration();
	                localctx.externalFunctions.push(localctx._externalFunctionDeclaration);
	                break;
	            case 63:
	                this.state = 227;
	                localctx._typeDefinition = this.typeDefinition();
	                localctx.types.push(localctx._typeDefinition);
	                break;
	            case 42:
	            case 55:
	                this.state = 228;
	                localctx._nodeDeclaration = this.nodeDeclaration();
	                localctx.nodes.push(localctx._nodeDeclaration);
	                break;
	            case 10:
	            case 11:
	            case 57:
	                this.state = 229;
	                localctx._blockDeclaration = this.blockDeclaration();
	                localctx.blocks.push(localctx._blockDeclaration);
	                break;
	            case 21:
	            case 33:
	            case 49:
	                this.state = 230;
	                localctx._digressionDeclaration = this.digressionDeclaration();
	                localctx.digressions.push(localctx._digressionDeclaration);
	                break;
	            case 32:
	            case 106:
	            case 107:
	            case 108:
	                this.state = 231;
	                localctx._contextFunctionDescription = this.contextFunctionDescription();
	                localctx.contextFunctions.push(localctx._contextFunctionDescription);
	                break;
	            case 66:
	                this.state = 232;
	                localctx._whenDescription = this.whenDescription();
	                localctx.whenDescriptions.push(localctx._whenDescription);
	                break;
	            default:
	                throw new antlr4.error.NoViableAltException(this);
	            }
	            this.state = 237;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	systemDescription() {
	    let localctx = new SystemDescriptionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 8, graphParser.RULE_systemDescription);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 238;
	        this.match(graphParser.LCURL);
	        this.state = 244;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===105) {
	            this.state = 239;
	            localctx._systemElementDescription = this.systemElementDescription();
	            localctx.elements.push(localctx._systemElementDescription);
	            this.state = 240;
	            this.objectTypeElementSeparator();
	            this.state = 246;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	        this.state = 247;
	        this.match(graphParser.RCURL);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	systemElementDescription() {
	    let localctx = new SystemElementDescriptionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 10, graphParser.RULE_systemElementDescription);
	    try {
	        this.state = 257;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,8,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 249;
	            localctx.name = this.variableName();
	            this.state = 250;
	            this.match(graphParser.COLON);
	            this.state = 251;
	            localctx.value = this.expression(0);
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 253;
	            localctx.name = this.variableName();
	            this.state = 254;
	            this.match(graphParser.EQUALSIGN);
	            this.state = 255;
	            localctx.value = this.expression(0);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	contextDescription() {
	    let localctx = new ContextDescriptionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 12, graphParser.RULE_contextDescription);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 259;
	        this.match(graphParser.LCURL);
	        this.state = 265;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===38 || _la===48 || _la===105) {
	            this.state = 260;
	            localctx._contextElementDescription = this.contextElementDescription();
	            localctx.elements.push(localctx._contextElementDescription);
	            this.state = 261;
	            this.objectTypeElementSeparator();
	            this.state = 267;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	        this.state = 268;
	        this.match(graphParser.RCURL);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	contextElementDescription() {
	    let localctx = new ContextElementDescriptionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 14, graphParser.RULE_contextElementDescription);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 272;
	        this._errHandler.sync(this);
	        switch (this._input.LA(1)) {
	        case 38:
	        	this.state = 270;
	        	localctx.input = this.match(graphParser.INPUT);
	        	break;
	        case 48:
	        	this.state = 271;
	        	localctx.output = this.match(graphParser.OUTPUT);
	        	break;
	        case 105:
	        	break;
	        default:
	        	break;
	        }
	        this.state = 274;
	        localctx.name = this.variableName();
	        this.state = 275;
	        this.match(graphParser.COLON);
	        this.state = 276;
	        localctx.type = this.typeDescription();
	        this.state = 279;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===94) {
	            this.state = 277;
	            this.match(graphParser.EQUALSIGN);
	            this.state = 278;
	            localctx.value = this.expression(0);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	externalFunctionDeclaration() {
	    let localctx = new ExternalFunctionDeclarationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 16, graphParser.RULE_externalFunctionDeclaration);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 281;
	        this.match(graphParser.EXTERNAL);
	        this.state = 282;
	        this.match(graphParser.FUNCTION);
	        this.state = 283;
	        localctx.name = this.externalFunctionName();
	        this.state = 284;
	        this.match(graphParser.LPAREN);
	        this.state = 285;
	        localctx.parameters = this.parameterList();
	        this.state = 286;
	        this.match(graphParser.RPAREN);
	        this.state = 287;
	        this.match(graphParser.COLON);
	        this.state = 288;
	        localctx.returnType = this.typeDescription();
	        this.state = 289;
	        this.match(graphParser.SEMICOLON);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	importDefinition() {
	    let localctx = new ImportDefinitionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 18, graphParser.RULE_importDefinition);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 291;
	        this.match(graphParser.IMPORT);
	        this.state = 292;
	        localctx.path = this.match(graphParser.StringLiteral);
	        this.state = 293;
	        this.match(graphParser.SEMICOLON);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	whenDescription() {
	    let localctx = new WhenDescriptionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 20, graphParser.RULE_whenDescription);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 295;
	        this.match(graphParser.WHEN);
	        this.state = 296;
	        localctx.event = this.match(graphParser.ID);
	        this.state = 298;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===105) {
	            this.state = 297;
	            localctx.name = this.whenId();
	        }

	        this.state = 302;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===50) {
	            this.state = 300;
	            this.match(graphParser.PRIORITY);
	            this.state = 301;
	            localctx.priority = this.match(graphParser.DecimalIntegerLiteral);
	        }

	        this.state = 304;
	        localctx.doSec = this.doSection();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	typeDefinition() {
	    let localctx = new TypeDefinitionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 22, graphParser.RULE_typeDefinition);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 306;
	        this.match(graphParser.TYPE);
	        this.state = 307;
	        this.typeAlias();
	        this.state = 308;
	        this.match(graphParser.EQUALSIGN);
	        this.state = 309;
	        this.typeDescription();
	        this.state = 319;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===8) {
	            this.state = 310;
	            this.match(graphParser.WITH);
	            this.state = 311;
	            this.match(graphParser.LCURL);
	            this.state = 315;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(((((_la - 105)) & ~0x1f) === 0 && ((1 << (_la - 105)) & 15) !== 0)) {
	                this.state = 312;
	                localctx._functionDescription = this.functionDescription();
	                localctx.functions.push(localctx._functionDescription);
	                this.state = 317;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }
	            this.state = 318;
	            this.match(graphParser.RCURL);
	        }

	        this.state = 321;
	        this.match(graphParser.SEMICOLON);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	functionDescription() {
	    let localctx = new FunctionDescriptionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 24, graphParser.RULE_functionDescription);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.enableChannel(2);
	        this.state = 331;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,18,this._ctx);
	        if(la_===1) {
	            this.state = 328;
	            this._errHandler.sync(this);
	            var _alt = this._interp.adaptivePredict(this._input,17,this._ctx)
	            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	                if(_alt===1) {
	                    this.state = 326;
	                    this._errHandler.sync(this);
	                    switch(this._input.LA(1)) {
	                    case 106:
	                        this.state = 324;
	                        localctx._LineComment = this.match(graphParser.LineComment);
	                        localctx.comments.push(localctx._LineComment);
	                        break;
	                    case 108:
	                        this.state = 325;
	                        this.match(graphParser.BlockComment);
	                        break;
	                    default:
	                        throw new antlr4.error.NoViableAltException(this);
	                    } 
	                }
	                this.state = 330;
	                this._errHandler.sync(this);
	                _alt = this._interp.adaptivePredict(this._input,17,this._ctx);
	            }


	        }
	        this.state = 334;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===107) {
	            this.state = 333;
	            localctx.doc = this.match(graphParser.DocsComment);
	        }

	        this.state = 343;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,22,this._ctx);
	        if(la_===1) {
	            this.state = 340;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(_la===106 || _la===108) {
	                this.state = 338;
	                this._errHandler.sync(this);
	                switch(this._input.LA(1)) {
	                case 106:
	                    this.state = 336;
	                    localctx._LineComment = this.match(graphParser.LineComment);
	                    localctx.comments.push(localctx._LineComment);
	                    break;
	                case 108:
	                    this.state = 337;
	                    this.match(graphParser.BlockComment);
	                    break;
	                default:
	                    throw new antlr4.error.NoViableAltException(this);
	                }
	                this.state = 342;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }

	        }
	        this.disableChannel(2);
	        this.state = 346;
	        localctx.name = this.functionName();
	        this.state = 347;
	        this.match(graphParser.LPAREN);
	        this.state = 348;
	        localctx.parameters = this.parameterList();
	        this.state = 349;
	        this.match(graphParser.RPAREN);
	        this.state = 350;
	        this.match(graphParser.COLON);
	        this.state = 351;
	        localctx.returnType = this.typeDescription();
	        this.state = 352;
	        localctx.body = this.blockBody();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	contextFunctionDescription() {
	    let localctx = new ContextFunctionDescriptionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 26, graphParser.RULE_contextFunctionDescription);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.enableChannel(2);
	        this.state = 362;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,25,this._ctx);
	        if(la_===1) {
	            this.state = 359;
	            this._errHandler.sync(this);
	            var _alt = this._interp.adaptivePredict(this._input,24,this._ctx)
	            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	                if(_alt===1) {
	                    this.state = 357;
	                    this._errHandler.sync(this);
	                    switch(this._input.LA(1)) {
	                    case 106:
	                        this.state = 355;
	                        localctx._LineComment = this.match(graphParser.LineComment);
	                        localctx.comments.push(localctx._LineComment);
	                        break;
	                    case 108:
	                        this.state = 356;
	                        this.match(graphParser.BlockComment);
	                        break;
	                    default:
	                        throw new antlr4.error.NoViableAltException(this);
	                    } 
	                }
	                this.state = 361;
	                this._errHandler.sync(this);
	                _alt = this._interp.adaptivePredict(this._input,24,this._ctx);
	            }


	        }
	        this.state = 365;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===107) {
	            this.state = 364;
	            localctx.doc = this.match(graphParser.DocsComment);
	        }

	        this.state = 374;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,29,this._ctx);
	        if(la_===1) {
	            this.state = 371;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(_la===106 || _la===108) {
	                this.state = 369;
	                this._errHandler.sync(this);
	                switch(this._input.LA(1)) {
	                case 106:
	                    this.state = 367;
	                    localctx._LineComment = this.match(graphParser.LineComment);
	                    localctx.comments.push(localctx._LineComment);
	                    break;
	                case 108:
	                    this.state = 368;
	                    this.match(graphParser.BlockComment);
	                    break;
	                default:
	                    throw new antlr4.error.NoViableAltException(this);
	                }
	                this.state = 373;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }

	        }
	        this.disableChannel(2);
	        this.state = 377;
	        this.match(graphParser.FUNCTION);
	        this.state = 378;
	        localctx.name = this.functionName();
	        this.state = 379;
	        this.match(graphParser.LPAREN);
	        this.state = 380;
	        localctx.parameters = this.parameterList();
	        this.state = 381;
	        this.match(graphParser.RPAREN);
	        this.state = 382;
	        this.match(graphParser.COLON);
	        this.state = 383;
	        localctx.returnType = this.typeDescription();
	        this.state = 384;
	        localctx.body = this.blockBody();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	blockDeclaration() {
	    let localctx = new BlockDeclarationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 28, graphParser.RULE_blockDeclaration);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 406;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,32,this._ctx);
	        switch(la_) {
	        case 1:
	            this.state = 387;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===57) {
	                this.state = 386;
	                localctx.sync = this.match(graphParser.SYNC);
	            }

	            this.state = 389;
	            this.match(graphParser.BLOCK);
	            this.state = 390;
	            this.blockId();
	            this.state = 391;
	            this.match(graphParser.LPAREN);
	            this.state = 392;
	            this.parameterList();
	            this.state = 393;
	            this.match(graphParser.RPAREN);
	            this.state = 394;
	            this.match(graphParser.COLON);
	            this.state = 395;
	            localctx.returnType = this.typeDescription();
	            break;

	        case 2:
	            this.state = 398;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===10) {
	                this.state = 397;
	                localctx.async = this.match(graphParser.ASYNC);
	            }

	            this.state = 400;
	            this.match(graphParser.BLOCK);
	            this.state = 401;
	            this.blockId();
	            this.state = 402;
	            this.match(graphParser.LPAREN);
	            this.state = 403;
	            this.parameterList();
	            this.state = 404;
	            this.match(graphParser.RPAREN);
	            break;

	        }
	        this.state = 408;
	        this.match(graphParser.LCURL);
	        this.state = 409;
	        localctx.content = this.blockContent();
	        this.state = 410;
	        this.match(graphParser.RCURL);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	nodeDeclaration() {
	    let localctx = new NodeDeclarationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 30, graphParser.RULE_nodeDeclaration);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 413;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===55) {
	            this.state = 412;
	            localctx.start = this.match(graphParser.START);
	        }

	        this.state = 415;
	        this.match(graphParser.NODE);
	        this.state = 416;
	        localctx.name = this.nodeId();
	        this.state = 417;
	        this.match(graphParser.LCURL);
	        this.state = 419;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===14) {
	            this.state = 418;
	            this.comment();
	        }

	        this.state = 421;
	        localctx.content = this.nodeContent();
	        this.state = 422;
	        this.match(graphParser.RCURL);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	digressionDeclaration() {
	    let localctx = new DigressionDeclarationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 32, graphParser.RULE_digressionDeclaration);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 425;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===33) {
	            this.state = 424;
	            localctx.global = this.match(graphParser.GLOBAL);
	        }

	        this.state = 428;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===49) {
	            this.state = 427;
	            localctx.preprocessor = this.match(graphParser.PREPROCESSOR);
	        }

	        this.state = 430;
	        this.match(graphParser.DIGRESSION);
	        this.state = 431;
	        localctx.name = this.digressionId();
	        this.state = 432;
	        this.match(graphParser.LCURL);
	        this.state = 433;
	        this.digressionContent();
	        this.state = 434;
	        this.match(graphParser.RCURL);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	digressionContent() {
	    let localctx = new DigressionContentContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 34, graphParser.RULE_digressionContent);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 436;
	        this.match(graphParser.CONDITIONS);
	        this.state = 437;
	        this.match(graphParser.LCURL);
	        this.state = 443;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===45) {
	            this.state = 438;
	            localctx._transitionDefinitionOnMessage = this.transitionDefinitionOnMessage();
	            localctx.transitions.push(localctx._transitionDefinitionOnMessage);
	            this.state = 439;
	            this.match(graphParser.SEMICOLON);
	            this.state = 445;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	        this.state = 446;
	        this.match(graphParser.RCURL);
	        this.state = 456;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===54 || _la===64) {
	            this.state = 450;
	            this._errHandler.sync(this);
	            switch(this._input.LA(1)) {
	            case 54:
	                this.state = 447;
	                this.match(graphParser.SHARED);
	                this.state = 448;
	                localctx._variableDefinition = this.variableDefinition();
	                localctx.sharedState.push(localctx._variableDefinition);
	                break;
	            case 64:
	                this.state = 449;
	                localctx._variableDefinition = this.variableDefinition();
	                localctx.copiedState.push(localctx._variableDefinition);
	                break;
	            default:
	                throw new antlr4.error.NoViableAltException(this);
	            }
	            this.state = 452;
	            this.match(graphParser.SEMICOLON);
	            this.state = 458;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	        this.state = 459;
	        this.nodeContent();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	comment() {
	    let localctx = new CommentContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 36, graphParser.RULE_comment);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 461;
	        this.match(graphParser.COMMENT);
	        this.state = 462;
	        this.match(graphParser.StringLiteral);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	nodeContent() {
	    let localctx = new NodeContentContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 38, graphParser.RULE_nodeContent);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 464;
	        localctx.doSec = this.doSection();
	        this.state = 466;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===60) {
	            this.state = 465;
	            localctx.transitions = this.nodeTransitionSection();
	        }

	        this.state = 470;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===49) {
	            this.state = 468;
	            this.match(graphParser.PREPROCESSOR);
	            this.state = 469;
	            localctx.preExit = this.doSection();
	        }

	        this.state = 473;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===47) {
	            this.state = 472;
	            localctx.onExit = this.nodeOnExitSection();
	        }

	        this.state = 476;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===46) {
	            this.state = 475;
	            this.nodeOnDigressionReturnSection();
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	nodeOnExitSection() {
	    let localctx = new NodeOnExitSectionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 40, graphParser.RULE_nodeOnExitSection);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 478;
	        this.match(graphParser.ONEXIT);
	        this.state = 479;
	        this.match(graphParser.LCURL);
	        this.state = 483;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===105) {
	            this.state = 480;
	            this.nodeOnExitSectionItem();
	            this.state = 485;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	        this.state = 489;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===19) {
	            this.state = 486;
	            this.match(graphParser.DEFAULT);
	            this.state = 487;
	            this.match(graphParser.COLON);
	            this.state = 488;
	            localctx.defaultDo = this.onExitDoWithConfident();
	        }

	        this.state = 494;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===21) {
	            this.state = 491;
	            this.match(graphParser.DIGRESSION);
	            this.state = 492;
	            this.match(graphParser.COLON);
	            this.state = 493;
	            localctx.digressionDo = this.onExitDoWithConfident();
	        }

	        this.state = 496;
	        this.match(graphParser.RCURL);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	nodeOnExitSectionItem() {
	    let localctx = new NodeOnExitSectionItemContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 42, graphParser.RULE_nodeOnExitSectionItem);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 501; 
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        do {
	            this.state = 498;
	            this.transitionName();
	            this.state = 499;
	            this.match(graphParser.COLON);
	            this.state = 503; 
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        } while(_la===105);
	        this.state = 505;
	        this.onExitDoWithConfident();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	onExitDoWithConfident() {
	    let localctx = new OnExitDoWithConfidentContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 44, graphParser.RULE_onExitDoWithConfident);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 507;
	        localctx.doSec = this.doSection();
	        this.state = 511;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===45) {
	            this.state = 508;
	            this.match(graphParser.ON);
	            this.state = 509;
	            this.match(graphParser.CONFIDENT);
	            this.state = 510;
	            localctx.confidentDo = this.doSection();
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	nodeOnDigressionReturnSection() {
	    let localctx = new NodeOnDigressionReturnSectionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 46, graphParser.RULE_nodeOnDigressionReturnSection);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 513;
	        this.match(graphParser.ONDIGRETURN);
	        this.state = 514;
	        this.blockBody();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	nodeTransitionSection() {
	    let localctx = new NodeTransitionSectionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 48, graphParser.RULE_nodeTransitionSection);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 516;
	        this.match(graphParser.TRANSITIONS);
	        this.state = 517;
	        this.match(graphParser.LCURL);
	        this.state = 521;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===105) {
	            this.state = 518;
	            localctx._namedTransitionDefinition = this.namedTransitionDefinition();
	            localctx.list.push(localctx._namedTransitionDefinition);
	            this.state = 523;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	        this.state = 524;
	        this.match(graphParser.RCURL);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	namedTransitionDefinition() {
	    let localctx = new NamedTransitionDefinitionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 50, graphParser.RULE_namedTransitionDefinition);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 526;
	        this.transitionName();
	        this.state = 527;
	        this.match(graphParser.COLON);
	        this.state = 528;
	        this.match(graphParser.GOTO);
	        this.state = 529;
	        localctx.target = this.nodeId();
	        this.state = 530;
	        this.transitionDefinition();
	        this.state = 531;
	        this.match(graphParser.SEMICOLON);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	transitionDefinition() {
	    let localctx = new TransitionDefinitionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 52, graphParser.RULE_transitionDefinition);
	    try {
	        this.state = 535;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 45:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 533;
	            this.transitionDefinitionOnMessage();
	            break;
	        case 90:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 534;
	            this.unconditionalTransitionDefinition();
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	transitionDefinitionOnMessage() {
	    let localctx = new TransitionDefinitionOnMessageContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 54, graphParser.RULE_transitionDefinitionOnMessage);
	    try {
	        this.state = 539;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,51,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 537;
	            this.conditionalTransitionDefinition();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 538;
	            this.timeoutTransitionDefinition();
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	timeoutTransitionDefinition() {
	    let localctx = new TimeoutTransitionDefinitionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 56, graphParser.RULE_timeoutTransitionDefinition);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 541;
	        this.match(graphParser.ON);
	        this.state = 542;
	        this.match(graphParser.TIMEOUT);
	        this.state = 543;
	        localctx.timeout = this.anyNumber();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	conditionalTransitionDefinition() {
	    let localctx = new ConditionalTransitionDefinitionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 58, graphParser.RULE_conditionalTransitionDefinition);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 545;
	        this.match(graphParser.ON);
	        this.state = 546;
	        localctx.condition = this.expression(0);
	        this.state = 549;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===50) {
	            this.state = 547;
	            this.match(graphParser.PRIORITY);
	            this.state = 548;
	            localctx.priority = this.match(graphParser.DecimalIntegerLiteral);
	        }

	        this.state = 553;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===66) {
	            this.state = 551;
	            this.match(graphParser.WHEN);
	            this.state = 552;
	            localctx.confident = this.match(graphParser.CONFIDENT);
	        }

	        this.state = 567;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===61) {
	            this.state = 555;
	            this.match(graphParser.TAGS);
	            this.state = 556;
	            this.match(graphParser.COLON);
	            this.state = 565;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===105) {
	                this.state = 557;
	                localctx._tagName = this.tagName();
	                localctx.tags.push(localctx._tagName);
	                this.state = 562;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	                while(_la===91) {
	                    this.state = 558;
	                    this.match(graphParser.COMMA);
	                    this.state = 559;
	                    localctx._tagName = this.tagName();
	                    localctx.tags.push(localctx._tagName);
	                    this.state = 564;
	                    this._errHandler.sync(this);
	                    _la = this._input.LA(1);
	                }
	            }

	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	unconditionalTransitionDefinition() {
	    let localctx = new UnconditionalTransitionDefinitionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 60, graphParser.RULE_unconditionalTransitionDefinition);
	    try {
	        this.enterOuterAlt(localctx, 1);

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	doSection() {
	    let localctx = new DoSectionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 62, graphParser.RULE_doSection);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 571;
	        this.match(graphParser.DO);
	        this.state = 572;
	        this.blockBody();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	blockBody() {
	    let localctx = new BlockBodyContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 64, graphParser.RULE_blockBody);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 574;
	        this.match(graphParser.LCURL);
	        this.state = 578;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while((((_la) & ~0x1f) === 0 && ((1 << _la) & 2954891278) !== 0) || ((((_la - 34)) & ~0x1f) === 0 && ((1 << (_la - 34)) & 3221880963) !== 0) || ((((_la - 67)) & ~0x1f) === 0 && ((1 << (_la - 67)) & 665663) !== 0) || _la===104 || _la===105) {
	            this.state = 575;
	            localctx._oneOrGroupedCommand = this.oneOrGroupedCommand();
	            localctx.commands.push(localctx._oneOrGroupedCommand);
	            this.state = 580;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	        this.state = 581;
	        this.match(graphParser.RCURL);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	oneOrGroupedCommand() {
	    let localctx = new OneOrGroupedCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 66, graphParser.RULE_oneOrGroupedCommand);
	    try {
	        this.state = 585;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,58,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 583;
	            this.nodeCommand();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 584;
	            this.blockBody();
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	nodeCommand() {
	    let localctx = new NodeCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 68, graphParser.RULE_nodeCommand);
	    try {
	        this.state = 590;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 1:
	        case 2:
	        case 3:
	        case 12:
	        case 21:
	        case 28:
	        case 29:
	        case 34:
	        case 41:
	        case 51:
	        case 53:
	        case 64:
	        case 65:
	        case 67:
	        case 68:
	        case 69:
	        case 70:
	        case 71:
	        case 72:
	        case 78:
	        case 80:
	        case 84:
	        case 86:
	        case 104:
	        case 105:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 587;
	            this.statement();
	            break;
	        case 35:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 588;
	            this.conditionalCommand();
	            break;
	        case 31:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 589;
	            this.cycleCommand();
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	cycleCommand() {
	    let localctx = new CycleCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 70, graphParser.RULE_cycleCommand);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 592;
	        this.foreachCommand();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	statement() {
	    let localctx = new StatementContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 72, graphParser.RULE_statement);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 594;
	        this.statementBody();
	        this.state = 595;
	        this.match(graphParser.SEMICOLON);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	statementBody() {
	    let localctx = new StatementBodyContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 74, graphParser.RULE_statementBody);
	    try {
	        this.state = 606;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,60,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 597;
	            this.waitCommand();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 598;
	            this.gotoCommand();
	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 599;
	            this.setCommand();
	            break;

	        case 4:
	            this.enterOuterAlt(localctx, 4);
	            this.state = 600;
	            this.returnCommand();
	            break;

	        case 5:
	            this.enterOuterAlt(localctx, 5);
	            this.state = 601;
	            this.exitCommand();
	            break;

	        case 6:
	            this.enterOuterAlt(localctx, 6);
	            this.state = 602;
	            this.assignOpCommand();
	            break;

	        case 7:
	            this.enterOuterAlt(localctx, 7);
	            this.state = 603;
	            this.variableDefinition();
	            break;

	        case 8:
	            this.enterOuterAlt(localctx, 8);
	            this.state = 604;
	            this.logExpressionTypeCommand();
	            break;

	        case 9:
	            this.enterOuterAlt(localctx, 9);
	            this.state = 605;
	            this.expression(0);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	logExpressionTypeCommand() {
	    let localctx = new LogExpressionTypeCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 76, graphParser.RULE_logExpressionTypeCommand);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 608;
	        this.match(graphParser.LOGEXPR);
	        this.state = 609;
	        this.expression(0);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	digressionControl() {
	    let localctx = new DigressionControlContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 78, graphParser.RULE_digressionControl);
	    try {
	        this.state = 623;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,61,this._ctx);
	        switch(la_) {
	        case 1:
	            localctx = new EnableDigressionContext(this, localctx);
	            this.enterOuterAlt(localctx, 1);
	            this.state = 611;
	            this.match(graphParser.DIGRESSION);
	            this.state = 612;
	            this.match(graphParser.ENABLE);
	            this.state = 613;
	            localctx.spec = this.digressionSpec();
	            break;

	        case 2:
	            localctx = new DisableDigressionContext(this, localctx);
	            this.enterOuterAlt(localctx, 2);
	            this.state = 614;
	            this.match(graphParser.DIGRESSION);
	            this.state = 615;
	            this.match(graphParser.DISABLE);
	            this.state = 616;
	            localctx.spec = this.digressionSpec();
	            break;

	        case 3:
	            localctx = new SaveDigressionContext(this, localctx);
	            this.enterOuterAlt(localctx, 3);
	            this.state = 617;
	            this.match(graphParser.DIGRESSION);
	            this.state = 618;
	            this.match(graphParser.SAVE);
	            this.state = 619;
	            localctx.spec = this.digressionSpec();
	            break;

	        case 4:
	            localctx = new ApplyDigressionContext(this, localctx);
	            this.enterOuterAlt(localctx, 4);
	            this.state = 620;
	            this.match(graphParser.DIGRESSION);
	            this.state = 621;
	            this.match(graphParser.APPLY);
	            this.state = 622;
	            localctx.mask = this.expression(0);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	digressionSpec() {
	    let localctx = new DigressionSpecContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 80, graphParser.RULE_digressionSpec);
	    var _la = 0;
	    try {
	        this.state = 637;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 105:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 625;
	            localctx._digressionId = this.digressionId();
	            localctx.list.push(localctx._digressionId);
	            break;
	        case 86:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 626;
	            this.match(graphParser.LCURL);
	            this.state = 627;
	            localctx._digressionId = this.digressionId();
	            localctx.list.push(localctx._digressionId);
	            this.state = 632;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(_la===91) {
	                this.state = 628;
	                this.match(graphParser.COMMA);
	                this.state = 629;
	                localctx._digressionId = this.digressionId();
	                localctx.list.push(localctx._digressionId);
	                this.state = 634;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }
	            this.state = 635;
	            this.match(graphParser.RCURL);
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	exitCommand() {
	    let localctx = new ExitCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 82, graphParser.RULE_exitCommand);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 639;
	        this.match(graphParser.EXIT);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	returnCommand() {
	    let localctx = new ReturnCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 84, graphParser.RULE_returnCommand);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 641;
	        this.match(graphParser.RETURN);
	        this.state = 643;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if((((_la) & ~0x1f) === 0 && ((1 << _la) & 270536718) !== 0) || ((((_la - 67)) & ~0x1f) === 0 && ((1 << (_la - 67)) & 665663) !== 0) || _la===104 || _la===105) {
	            this.state = 642;
	            localctx.returnValue = this.expression(0);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	variableDefinition() {
	    let localctx = new VariableDefinitionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 86, graphParser.RULE_variableDefinition);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 645;
	        this.variableDeclaration();
	        this.state = 648;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===89) {
	            this.state = 646;
	            this.match(graphParser.COLON);
	            this.state = 647;
	            localctx.type = this.typeDescription();
	        }

	        this.state = 652;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===94) {
	            this.state = 650;
	            this.match(graphParser.EQUALSIGN);
	            this.state = 651;
	            localctx.value = this.expression(0);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	variableDeclaration() {
	    let localctx = new VariableDeclarationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 88, graphParser.RULE_variableDeclaration);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 654;
	        this.match(graphParser.VAR);
	        this.state = 655;
	        this.variableName();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	typeDescription() {
	    let localctx = new TypeDescriptionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 90, graphParser.RULE_typeDescription);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 657;
	        this.type_();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	conditionalCommand() {
	    let localctx = new ConditionalCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 92, graphParser.RULE_conditionalCommand);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 659;
	        this.match(graphParser.IF);
	        this.state = 660;
	        this.match(graphParser.LPAREN);
	        this.state = 661;
	        localctx.condition = this.expression(0);
	        this.state = 662;
	        this.match(graphParser.RPAREN);
	        this.state = 663;
	        localctx.thenCommand = this.oneOrGroupedCommand();
	        this.state = 666;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,67,this._ctx);
	        if(la_===1) {
	            this.state = 664;
	            this.match(graphParser.ELSE);
	            this.state = 665;
	            localctx.elseCommand = this.oneOrGroupedCommand();

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	foreachCommand() {
	    let localctx = new ForeachCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 94, graphParser.RULE_foreachCommand);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 668;
	        this.match(graphParser.FOR);
	        this.state = 669;
	        this.match(graphParser.LPAREN);
	        this.state = 670;
	        this.variableDeclaration();
	        this.state = 671;
	        this.match(graphParser.IN);
	        this.state = 672;
	        localctx.container = this.expression(0);
	        this.state = 673;
	        this.match(graphParser.RPAREN);
	        this.state = 674;
	        localctx.body = this.oneOrGroupedCommand();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	waitCommand() {
	    let localctx = new WaitCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 96, graphParser.RULE_waitCommand);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 676;
	        this.match(graphParser.WAIT);
	        this.state = 677;
	        this.activatedTransitionList();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	activatedTransitionList() {
	    let localctx = new ActivatedTransitionListContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 98, graphParser.RULE_activatedTransitionList);
	    var _la = 0;
	    try {
	        this.state = 693;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 86:
	            localctx = new SelectedActivatedTransitionListContext(this, localctx);
	            this.enterOuterAlt(localctx, 1);
	            this.state = 679;
	            this.match(graphParser.LCURL);
	            this.state = 680;
	            this.transitionName();
	            this.state = 687;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(_la===91 || _la===105) {
	                this.state = 682;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	                if(_la===91) {
	                    this.state = 681;
	                    this.match(graphParser.COMMA);
	                }

	                this.state = 684;
	                this.transitionName();
	                this.state = 689;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }
	            this.state = 690;
	            this.match(graphParser.RCURL);
	            break;
	        case 4:
	            localctx = new AllActivatedTransitionListContext(this, localctx);
	            this.enterOuterAlt(localctx, 2);
	            this.state = 692;
	            this.match(graphParser.STAR);
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	gotoCommand() {
	    let localctx = new GotoCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 100, graphParser.RULE_gotoCommand);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 695;
	        this.match(graphParser.GOTO);
	        this.state = 696;
	        this.transitionName();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	setCommand() {
	    let localctx = new SetCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 102, graphParser.RULE_setCommand);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 698;
	        this.match(graphParser.SET);
	        this.state = 699;
	        localctx.ref = this.lValue(0);
	        this.state = 700;
	        this.match(graphParser.EQUALSIGN);
	        this.state = 701;
	        localctx.rightPartExpression = this.expression(0);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	assignOpCommand() {
	    let localctx = new AssignOpCommandContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 104, graphParser.RULE_assignOpCommand);
	    try {
	        this.state = 713;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,71,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 703;
	            this.match(graphParser.SET);
	            this.state = 704;
	            localctx.ref = this.lValue(0);
	            this.state = 705;
	            localctx.op = this.match(graphParser.AddOp);
	            this.state = 706;
	            localctx.rightPartExpression = this.expression(0);
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 708;
	            this.match(graphParser.SET);
	            this.state = 709;
	            localctx.ref = this.lValue(0);
	            this.state = 710;
	            localctx.op = this.match(graphParser.RemoveOp);
	            this.state = 711;
	            localctx.rightPartExpression = this.expression(0);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


	lValue(_p) {
		if(_p===undefined) {
		    _p = 0;
		}
	    const _parentctx = this._ctx;
	    const _parentState = this.state;
	    let localctx = new LValueContext(this, this._ctx, _parentState);
	    let _prevctx = localctx;
	    const _startState = 106;
	    this.enterRecursionRule(localctx, 106, graphParser.RULE_lValue, _p);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 721;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 84:
	            localctx = new LValueParenthesizedExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;

	            this.state = 716;
	            this.match(graphParser.LPAREN);
	            this.state = 717;
	            this.lValue(0);
	            this.state = 718;
	            this.match(graphParser.RPAREN);
	            break;
	        case 21:
	        case 68:
	        case 69:
	        case 105:
	            localctx = new LValueReferenceExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 720;
	            this.reference();
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	        this._ctx.stop = this._input.LT(-1);
	        this.state = 737;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,74,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                if(this._parseListeners!==null) {
	                    this.triggerExitRuleEvent();
	                }
	                _prevctx = localctx;
	                this.state = 735;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,73,this._ctx);
	                switch(la_) {
	                case 1:
	                    localctx = new LValueDotAccessExpressionContext(this, new LValueContext(this, _parentctx, _parentState));
	                    localctx.parent = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_lValue);
	                    this.state = 723;
	                    if (!( this.precpred(this._ctx, 3))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 3)");
	                    }
	                    this.state = 724;
	                    this.match(graphParser.PERIOD);
	                    this.state = 725;
	                    localctx.member = this.memberName();
	                    break;

	                case 2:
	                    localctx = new LValueLiteralIndexAccessExpressionContext(this, new LValueContext(this, _parentctx, _parentState));
	                    localctx.parent = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_lValue);
	                    this.state = 726;
	                    if (!( this.precpred(this._ctx, 2))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 2)");
	                    }
	                    this.state = 727;
	                    this.match(graphParser.LBRACKET);
	                    this.state = 728;
	                    localctx.index = this.match(graphParser.DecimalIntegerLiteral);
	                    this.state = 729;
	                    this.match(graphParser.RBRACKET);
	                    break;

	                case 3:
	                    localctx = new LValueExpressionIndexAccessExpressionContext(this, new LValueContext(this, _parentctx, _parentState));
	                    localctx.parent = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_lValue);
	                    this.state = 730;
	                    if (!( this.precpred(this._ctx, 1))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 1)");
	                    }
	                    this.state = 731;
	                    this.match(graphParser.LBRACKET);
	                    this.state = 732;
	                    localctx.index = this.expression(0);
	                    this.state = 733;
	                    this.match(graphParser.RBRACKET);
	                    break;

	                } 
	            }
	            this.state = 739;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,74,this._ctx);
	        }

	    } catch( error) {
	        if(error instanceof antlr4.error.RecognitionException) {
		        localctx.exception = error;
		        this._errHandler.reportError(this, error);
		        this._errHandler.recover(this, error);
		    } else {
		    	throw error;
		    }
	    } finally {
	        this.unrollRecursionContexts(_parentctx)
	    }
	    return localctx;
	}


	expression(_p) {
		if(_p===undefined) {
		    _p = 0;
		}
	    const _parentctx = this._ctx;
	    const _parentState = this.state;
	    let localctx = new ExpressionContext(this, this._ctx, _parentState);
	    let _prevctx = localctx;
	    const _startState = 108;
	    this.enterRecursionRule(localctx, 108, graphParser.RULE_expression, _p);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 788;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,80,this._ctx);
	        switch(la_) {
	        case 1:
	            localctx = new ExternFunctionCallExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;

	            this.state = 741;
	            this.externalFunctionCall();
	            break;

	        case 2:
	            localctx = new BuiltinFunctionCallExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 742;
	            this.builtinFunctionCall();
	            break;

	        case 3:
	            localctx = new BlockFunctionCallExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 743;
	            this.blockFunctionCall();
	            break;

	        case 4:
	            localctx = new BooleanLiteralExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 744;
	            this.match(graphParser.BooleanLiteral);
	            break;

	        case 5:
	            localctx = new SlotFillingCallExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 745;
	            this.slotFillingCall();
	            break;

	        case 6:
	            localctx = new NumberLiteralExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 746;
	            this.anyNumber();
	            break;

	        case 7:
	            localctx = new StringLiteralExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 747;
	            this.match(graphParser.StringLiteral);
	            break;

	        case 8:
	            localctx = new ParenthesizedExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 748;
	            this.match(graphParser.LPAREN);
	            this.state = 749;
	            this.expression(0);
	            this.state = 750;
	            this.match(graphParser.RPAREN);
	            break;

	        case 9:
	            localctx = new ReferenceExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 752;
	            this.reference();
	            break;

	        case 10:
	            localctx = new DigressionControlExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 753;
	            this.digressionControl();
	            break;

	        case 11:
	            localctx = new UnaryOpExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 754;
	            localctx.op = this._input.LT(1);
	            _la = this._input.LA(1);
	            if(!(_la===2 || _la===3 || _la===104)) {
	                localctx.op = this._errHandler.recoverInline(this);
	            }
	            else {
	            	this._errHandler.reportMatch(this);
	                this.consume();
	            }
	            this.state = 755;
	            this.expression(15);
	            break;

	        case 12:
	            localctx = new IsDefinedExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 756;
	            this.reference();
	            this.state = 757;
	            this.match(graphParser.IS);
	            this.state = 759;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===43) {
	                this.state = 758;
	                this.match(graphParser.NOT);
	            }

	            this.state = 761;
	            this.match(graphParser.DEFINED);
	            break;

	        case 13:
	            localctx = new ObjectLiteralExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 763;
	            this.match(graphParser.LCURL);
	            this.state = 772;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===1 || _la===105) {
	                this.state = 764;
	                localctx._objectPropertyExpressionPart = this.objectPropertyExpressionPart();
	                localctx.fields.push(localctx._objectPropertyExpressionPart);
	                this.state = 769;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	                while(_la===91) {
	                    this.state = 765;
	                    this.match(graphParser.COMMA);
	                    this.state = 766;
	                    localctx._objectPropertyExpressionPart = this.objectPropertyExpressionPart();
	                    localctx.fields.push(localctx._objectPropertyExpressionPart);
	                    this.state = 771;
	                    this._errHandler.sync(this);
	                    _la = this._input.LA(1);
	                }
	            }

	            this.state = 774;
	            this.match(graphParser.RCURL);
	            break;

	        case 14:
	            localctx = new TupleLiteralExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 775;
	            this.match(graphParser.LBRACKET);
	            this.state = 777;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if((((_la) & ~0x1f) === 0 && ((1 << _la) & 270536718) !== 0) || ((((_la - 67)) & ~0x1f) === 0 && ((1 << (_la - 67)) & 665663) !== 0) || _la===104 || _la===105) {
	                this.state = 776;
	                localctx._expression = this.expression(0);
	                localctx.elements.push(localctx._expression);
	            }

	            this.state = 783;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(_la===91) {
	                this.state = 779;
	                this.match(graphParser.COMMA);
	                this.state = 780;
	                localctx._expression = this.expression(0);
	                localctx.elements.push(localctx._expression);
	                this.state = 785;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }
	            this.state = 786;
	            this.match(graphParser.RBRACKET);
	            break;

	        case 15:
	            localctx = new NullLiteralExpressionContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 787;
	            this.match(graphParser.NULL);
	            break;

	        }
	        this._ctx.stop = this._input.LT(-1);
	        this.state = 856;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,83,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                if(this._parseListeners!==null) {
	                    this.triggerExitRuleEvent();
	                }
	                _prevctx = localctx;
	                this.state = 854;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,82,this._ctx);
	                switch(la_) {
	                case 1:
	                    localctx = new BinaryOpExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 790;
	                    if (!( this.precpred(this._ctx, 12))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 12)");
	                    }
	                    this.state = 791;
	                    localctx.op = this._input.LT(1);
	                    _la = this._input.LA(1);
	                    if(!((((_la) & ~0x1f) === 0 && ((1 << _la) & 112) !== 0))) {
	                        localctx.op = this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 792;
	                    localctx.right = this.expression(13);
	                    break;

	                case 2:
	                    localctx = new BinaryOpExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 793;
	                    if (!( this.precpred(this._ctx, 11))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 11)");
	                    }
	                    this.state = 794;
	                    localctx.op = this._input.LT(1);
	                    _la = this._input.LA(1);
	                    if(!(_la===2 || _la===3)) {
	                        localctx.op = this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 795;
	                    localctx.right = this.expression(12);
	                    break;

	                case 3:
	                    localctx = new BinaryOpExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 796;
	                    if (!( this.precpred(this._ctx, 10))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 10)");
	                    }
	                    this.state = 797;
	                    localctx.op = this._input.LT(1);
	                    _la = this._input.LA(1);
	                    if(!(((((_la - 81)) & ~0x1f) === 0 && ((1 << (_la - 81)) & 786435) !== 0))) {
	                        localctx.op = this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 798;
	                    localctx.right = this.expression(11);
	                    break;

	                case 4:
	                    localctx = new BinaryOpExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 799;
	                    if (!( this.precpred(this._ctx, 9))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 9)");
	                    }
	                    this.state = 800;
	                    localctx.op = this._input.LT(1);
	                    _la = this._input.LA(1);
	                    if(!(_la===97 || _la===98)) {
	                        localctx.op = this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 801;
	                    localctx.right = this.expression(10);
	                    break;

	                case 5:
	                    localctx = new BinaryOpExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 802;
	                    if (!( this.precpred(this._ctx, 8))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 8)");
	                    }
	                    this.state = 803;
	                    localctx.op = this.match(graphParser.AndOp);
	                    this.state = 804;
	                    localctx.right = this.expression(9);
	                    break;

	                case 6:
	                    localctx = new BinaryOpExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 805;
	                    if (!( this.precpred(this._ctx, 7))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 7)");
	                    }
	                    this.state = 806;
	                    localctx.op = this.match(graphParser.OrOp);
	                    this.state = 807;
	                    localctx.right = this.expression(8);
	                    break;

	                case 7:
	                    localctx = new NullCollateExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.nullable = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 808;
	                    if (!( this.precpred(this._ctx, 6))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 6)");
	                    }
	                    this.state = 809;
	                    this.match(graphParser.QMARK);
	                    this.state = 810;
	                    this.match(graphParser.QMARK);
	                    this.state = 811;
	                    localctx.defaultValue = this.expression(7);
	                    break;

	                case 8:
	                    localctx = new TernaryOpExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.condition = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 812;
	                    if (!( this.precpred(this._ctx, 5))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 5)");
	                    }
	                    this.state = 813;
	                    this.match(graphParser.QMARK);
	                    this.state = 814;
	                    localctx.thenExpression = this.expression(0);
	                    this.state = 815;
	                    this.match(graphParser.COLON);
	                    this.state = 816;
	                    localctx.elseExpression = this.expression(5);
	                    break;

	                case 9:
	                    localctx = new DotAccessExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.parent = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 818;
	                    if (!( this.precpred(this._ctx, 23))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 23)");
	                    }
	                    this.state = 819;
	                    this.match(graphParser.PERIOD);
	                    this.state = 820;
	                    localctx.member = this.memberName();
	                    break;

	                case 10:
	                    localctx = new OptionalDotAccessExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.parent = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 821;
	                    if (!( this.precpred(this._ctx, 22))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 22)");
	                    }
	                    this.state = 822;
	                    this.match(graphParser.QMARK);
	                    this.state = 823;
	                    this.match(graphParser.PERIOD);
	                    this.state = 824;
	                    localctx.member = this.memberName();
	                    break;

	                case 11:
	                    localctx = new CallDotAccessExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.parent = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 825;
	                    if (!( this.precpred(this._ctx, 21))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 21)");
	                    }
	                    this.state = 826;
	                    this.match(graphParser.PERIOD);
	                    this.state = 827;
	                    localctx.member = this.memberName();
	                    this.state = 828;
	                    localctx.arguments = this.argumentInvokation();
	                    break;

	                case 12:
	                    localctx = new OptionalCallDotAccessExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.parent = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 830;
	                    if (!( this.precpred(this._ctx, 20))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 20)");
	                    }
	                    this.state = 831;
	                    this.match(graphParser.QMARK);
	                    this.state = 832;
	                    this.match(graphParser.PERIOD);
	                    this.state = 833;
	                    localctx.member = this.memberName();
	                    this.state = 834;
	                    localctx.arguments = this.argumentInvokation();
	                    break;

	                case 13:
	                    localctx = new LiteralIndexAccessExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.parent = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 836;
	                    if (!( this.precpred(this._ctx, 19))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 19)");
	                    }
	                    this.state = 837;
	                    this.match(graphParser.LBRACKET);
	                    this.state = 838;
	                    localctx.index = this.match(graphParser.DecimalIntegerLiteral);
	                    this.state = 839;
	                    this.match(graphParser.RBRACKET);
	                    break;

	                case 14:
	                    localctx = new ExpressionIndexAccessExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.parent = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 840;
	                    if (!( this.precpred(this._ctx, 18))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 18)");
	                    }
	                    this.state = 841;
	                    this.match(graphParser.LBRACKET);
	                    this.state = 842;
	                    localctx.index = this.expression(0);
	                    this.state = 843;
	                    this.match(graphParser.RBRACKET);
	                    break;

	                case 15:
	                    localctx = new IsNullExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 845;
	                    if (!( this.precpred(this._ctx, 14))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 14)");
	                    }
	                    this.state = 846;
	                    this.match(graphParser.IS);
	                    this.state = 848;
	                    this._errHandler.sync(this);
	                    _la = this._input.LA(1);
	                    if(_la===43) {
	                        this.state = 847;
	                        this.match(graphParser.NOT);
	                    }

	                    this.state = 850;
	                    this.match(graphParser.NULL);
	                    break;

	                case 16:
	                    localctx = new CastExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_expression);
	                    this.state = 851;
	                    if (!( this.precpred(this._ctx, 1))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 1)");
	                    }
	                    this.state = 852;
	                    this.match(graphParser.AS);
	                    this.state = 853;
	                    this.typeDescription();
	                    break;

	                } 
	            }
	            this.state = 858;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,83,this._ctx);
	        }

	    } catch( error) {
	        if(error instanceof antlr4.error.RecognitionException) {
		        localctx.exception = error;
		        this._errHandler.reportError(this, error);
		        this._errHandler.recover(this, error);
		    } else {
		    	throw error;
		    }
	    } finally {
	        this.unrollRecursionContexts(_parentctx)
	    }
	    return localctx;
	}



	objectPropertyExpressionPart() {
	    let localctx = new ObjectPropertyExpressionPartContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 110, graphParser.RULE_objectPropertyExpressionPart);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 859;
	        localctx.name = this.propertyName();
	        this.state = 860;
	        this.match(graphParser.COLON);
	        this.state = 861;
	        this.expression(0);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	externalFunctionCall() {
	    let localctx = new ExternalFunctionCallContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 112, graphParser.RULE_externalFunctionCall);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 863;
	        this.match(graphParser.EXTERNAL);
	        this.state = 864;
	        localctx.name = this.externalFunctionName();
	        this.state = 865;
	        localctx.arguments = this.argumentInvokation();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	blockFunctionCall() {
	    let localctx = new BlockFunctionCallContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 114, graphParser.RULE_blockFunctionCall);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 867;
	        this.match(graphParser.BLOCKCALL);
	        this.state = 868;
	        localctx.name = this.blockId();
	        this.state = 869;
	        localctx.arguments = this.argumentInvokation();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	slotFillingCall() {
	    let localctx = new SlotFillingCallContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 116, graphParser.RULE_slotFillingCall);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 871;
	        this.match(graphParser.FILL);
	        this.state = 872;
	        localctx.name = this.typeAlias();
	        this.state = 873;
	        localctx.arguments = this.argumentInvokation();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	builtinFunctionCall() {
	    let localctx = new BuiltinFunctionCallContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 118, graphParser.RULE_builtinFunctionCall);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 875;
	        this.match(graphParser.BuiltinMark);
	        this.state = 876;
	        localctx.name = this.builtinFunctionName();
	        this.state = 877;
	        localctx.arguments = this.argumentInvokation();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	argumentInvokation() {
	    let localctx = new ArgumentInvokationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 120, graphParser.RULE_argumentInvokation);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 879;
	        this.match(graphParser.LPAREN);
	        this.state = 880;
	        this.argumentList();
	        this.state = 881;
	        this.match(graphParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	argumentList() {
	    let localctx = new ArgumentListContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 122, graphParser.RULE_argumentList);
	    var _la = 0;
	    try {
	        this.state = 890;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,85,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 883;
	            localctx.positional = this.positionalArgumentList();
	            this.state = 886;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===91) {
	                this.state = 884;
	                this.match(graphParser.COMMA);
	                this.state = 885;
	                localctx.named = this.namedArgumentList();
	            }

	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 888;
	            localctx.named = this.namedArgumentList();
	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);

	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	namedArgumentList() {
	    let localctx = new NamedArgumentListContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 124, graphParser.RULE_namedArgumentList);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 892;
	        localctx._namedArgument = this.namedArgument();
	        localctx.arguments.push(localctx._namedArgument);
	        this.state = 897;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===91) {
	            this.state = 893;
	            this.match(graphParser.COMMA);
	            this.state = 894;
	            localctx._namedArgument = this.namedArgument();
	            localctx.arguments.push(localctx._namedArgument);
	            this.state = 899;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	positionalArgumentList() {
	    let localctx = new PositionalArgumentListContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 126, graphParser.RULE_positionalArgumentList);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 900;
	        localctx._positionalArgument = this.positionalArgument();
	        localctx.arguments.push(localctx._positionalArgument);
	        this.state = 905;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,87,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                this.state = 901;
	                this.match(graphParser.COMMA);
	                this.state = 902;
	                localctx._positionalArgument = this.positionalArgument();
	                localctx.arguments.push(localctx._positionalArgument); 
	            }
	            this.state = 907;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,87,this._ctx);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	positionalArgument() {
	    let localctx = new PositionalArgumentContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 128, graphParser.RULE_positionalArgument);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 908;
	        this.expression(0);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	namedArgument() {
	    let localctx = new NamedArgumentContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 130, graphParser.RULE_namedArgument);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 910;
	        this.argumentName();
	        this.state = 911;
	        this.match(graphParser.COLON);
	        this.state = 912;
	        this.expression(0);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	parameterList() {
	    let localctx = new ParameterListContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 132, graphParser.RULE_parameterList);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 922;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===105) {
	            this.state = 914;
	            localctx._parameter = this.parameter();
	            localctx.parameters.push(localctx._parameter);
	            this.state = 919;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(_la===91) {
	                this.state = 915;
	                this.match(graphParser.COMMA);
	                this.state = 916;
	                localctx._parameter = this.parameter();
	                localctx.parameters.push(localctx._parameter);
	                this.state = 921;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	parameter() {
	    let localctx = new ParameterContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 134, graphParser.RULE_parameter);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 924;
	        localctx.name = this.parameterName();
	        this.state = 925;
	        this.match(graphParser.COLON);
	        this.state = 926;
	        localctx.type = this.typeDescription();
	        this.state = 929;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===94) {
	            this.state = 927;
	            this.match(graphParser.EQUALSIGN);
	            this.state = 928;
	            localctx.defaultValue = this.expression(0);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	reference() {
	    let localctx = new ReferenceContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 136, graphParser.RULE_reference);
	    try {
	        this.state = 951;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 68:
	            localctx = new BuiltinReferenceContext(this, localctx);
	            this.enterOuterAlt(localctx, 1);
	            this.state = 931;
	            this.match(graphParser.BuiltinMark);
	            this.state = 932;
	            localctx.refName = this.referenceName();
	            break;
	        case 105:
	            localctx = new LocalReferenceContext(this, localctx);
	            this.enterOuterAlt(localctx, 2);
	            this.state = 933;
	            localctx.refName = this.referenceName();
	            break;
	        case 69:
	            localctx = new ContextReferenceContext(this, localctx);
	            this.enterOuterAlt(localctx, 3);
	            this.state = 934;
	            this.match(graphParser.ContextMark);
	            this.state = 936;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,91,this._ctx);
	            if(la_===1) {
	                this.state = 935;
	                localctx.refName = this.referenceName();

	            }
	            break;
	        case 21:
	            localctx = new DigressionReferenceContext(this, localctx);
	            this.enterOuterAlt(localctx, 4);
	            this.state = 938;
	            this.match(graphParser.DIGRESSION);
	            this.state = 949;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,94,this._ctx);
	            if(la_===1) {
	                this.state = 939;
	                this.match(graphParser.PERIOD);
	                this.state = 940;
	                localctx.name = this.digressionId();
	                this.state = 943;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,92,this._ctx);
	                if(la_===1) {
	                    this.state = 941;
	                    this.match(graphParser.PERIOD);
	                    this.state = 942;
	                    localctx.shared = this.match(graphParser.SHARED);

	                }
	                this.state = 947;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,93,this._ctx);
	                if(la_===1) {
	                    this.state = 945;
	                    this.match(graphParser.PERIOD);
	                    this.state = 946;
	                    localctx.refName = this.referenceName();

	                }

	            }
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	whenId() {
	    let localctx = new WhenIdContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 138, graphParser.RULE_whenId);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 953;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	nodeId() {
	    let localctx = new NodeIdContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 140, graphParser.RULE_nodeId);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 955;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	blockId() {
	    let localctx = new BlockIdContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 142, graphParser.RULE_blockId);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 957;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	digressionId() {
	    let localctx = new DigressionIdContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 144, graphParser.RULE_digressionId);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 959;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	transitionName() {
	    let localctx = new TransitionNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 146, graphParser.RULE_transitionName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 961;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	referenceName() {
	    let localctx = new ReferenceNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 148, graphParser.RULE_referenceName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 963;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	memberName() {
	    let localctx = new MemberNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 150, graphParser.RULE_memberName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 965;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	tagName() {
	    let localctx = new TagNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 152, graphParser.RULE_tagName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 967;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	factName() {
	    let localctx = new FactNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 154, graphParser.RULE_factName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 969;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	fieldName() {
	    let localctx = new FieldNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 156, graphParser.RULE_fieldName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 971;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	variableName() {
	    let localctx = new VariableNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 158, graphParser.RULE_variableName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 973;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	argumentName() {
	    let localctx = new ArgumentNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 160, graphParser.RULE_argumentName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 975;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	parameterName() {
	    let localctx = new ParameterNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 162, graphParser.RULE_parameterName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 977;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	propertyName() {
	    let localctx = new PropertyNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 164, graphParser.RULE_propertyName);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 979;
	        _la = this._input.LA(1);
	        if(!(_la===1 || _la===105)) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	builtinFunctionName() {
	    let localctx = new BuiltinFunctionNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 166, graphParser.RULE_builtinFunctionName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 981;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	externalFunctionName() {
	    let localctx = new ExternalFunctionNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 168, graphParser.RULE_externalFunctionName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 983;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	functionName() {
	    let localctx = new FunctionNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 170, graphParser.RULE_functionName);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 985;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	anyNumber() {
	    let localctx = new AnyNumberContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 172, graphParser.RULE_anyNumber);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 987;
	        _la = this._input.LA(1);
	        if(!(_la===70 || _la===71)) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	typeEof() {
	    let localctx = new TypeEofContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 174, graphParser.RULE_typeEof);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 989;
	        this.type_();
	        this.state = 990;
	        this.match(graphParser.EOF);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	type_() {
	    let localctx = new Type_Context(this, this._ctx, this.state);
	    this.enterRule(localctx, 176, graphParser.RULE_type_);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 992;
	        localctx._nonNullableType = this.nonNullableType(0);
	        localctx.types.push(localctx._nonNullableType);
	        this.state = 993;
	        localctx._questionMarkOptional = this.questionMarkOptional();
	        localctx.nullableFlags.push(localctx._questionMarkOptional);
	        this.state = 1000;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,96,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                this.state = 994;
	                this.match(graphParser.TypeOr);
	                this.state = 995;
	                localctx._nonNullableType = this.nonNullableType(0);
	                localctx.types.push(localctx._nonNullableType);
	                this.state = 996;
	                localctx._questionMarkOptional = this.questionMarkOptional();
	                localctx.nullableFlags.push(localctx._questionMarkOptional); 
	            }
	            this.state = 1002;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,96,this._ctx);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	questionMarkOptional() {
	    let localctx = new QuestionMarkOptionalContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 178, graphParser.RULE_questionMarkOptional);
	    try {
	        this.state = 1005;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,97,this._ctx);
	        switch(la_) {
	        case 1:
	            localctx = new PresentQuestionMarkContext(this, localctx);
	            this.enterOuterAlt(localctx, 1);
	            this.state = 1003;
	            this.match(graphParser.QMARK);
	            break;

	        case 2:
	            localctx = new NoQuestionMarkContext(this, localctx);
	            this.enterOuterAlt(localctx, 2);

	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	objectTypeElementSeparator() {
	    let localctx = new ObjectTypeElementSeparatorContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 180, graphParser.RULE_objectTypeElementSeparator);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 1007;
	        _la = this._input.LA(1);
	        if(!(_la===90 || _la===91)) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


	nonNullableType(_p) {
		if(_p===undefined) {
		    _p = 0;
		}
	    const _parentctx = this._ctx;
	    const _parentState = this.state;
	    let localctx = new NonNullableTypeContext(this, this._ctx, _parentState);
	    let _prevctx = localctx;
	    const _startState = 182;
	    this.enterRecursionRule(localctx, 182, graphParser.RULE_nonNullableType, _p);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 1064;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 84:
	            localctx = new ParenthesisedTypeContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;

	            this.state = 1010;
	            this.match(graphParser.LPAREN);
	            this.state = 1011;
	            this.type_();
	            this.state = 1012;
	            this.match(graphParser.RPAREN);
	            break;
	        case 73:
	        case 74:
	        case 75:
	        case 76:
	        case 77:
	            localctx = new PredefinedTypeRefContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 1014;
	            this.predefinedType();
	            break;
	        case 86:
	            localctx = new ObjectTypeContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 1015;
	            this.match(graphParser.LCURL);
	            this.state = 1021;
	            this._errHandler.sync(this);
	            var _alt = this._interp.adaptivePredict(this._input,98,this._ctx)
	            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	                if(_alt===1) {
	                    this.state = 1016;
	                    localctx._propertySignature = this.propertySignature();
	                    localctx.properties.push(localctx._propertySignature);
	                    this.state = 1017;
	                    this.objectTypeElementSeparator(); 
	                }
	                this.state = 1023;
	                this._errHandler.sync(this);
	                _alt = this._interp.adaptivePredict(this._input,98,this._ctx);
	            }

	            this.state = 1027;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===80) {
	                this.state = 1024;
	                this.indexSignature();
	                this.state = 1025;
	                this.objectTypeElementSeparator();
	            }

	            this.state = 1034;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(_la===1 || _la===105) {
	                this.state = 1029;
	                localctx._propertySignature = this.propertySignature();
	                localctx.properties.push(localctx._propertySignature);
	                this.state = 1030;
	                this.objectTypeElementSeparator();
	                this.state = 1036;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }
	            this.state = 1037;
	            this.match(graphParser.RCURL);
	            break;
	        case 80:
	            localctx = new TupleTypeContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 1038;
	            this.match(graphParser.LBRACKET);
	            this.state = 1040;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===1 || ((((_la - 73)) & ~0x1f) === 0 && ((1 << (_la - 73)) & 10911) !== 0) || _la===105) {
	                this.state = 1039;
	                localctx._type_ = this.type_();
	                localctx.elementTypes.push(localctx._type_);
	            }

	            this.state = 1046;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(_la===91) {
	                this.state = 1042;
	                this.match(graphParser.COMMA);
	                this.state = 1043;
	                localctx._type_ = this.type_();
	                localctx.elementTypes.push(localctx._type_);
	                this.state = 1048;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }
	            this.state = 1049;
	            this.match(graphParser.RBRACKET);
	            break;
	        case 82:
	            localctx = new AngleUnionTypeContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 1050;
	            this.match(graphParser.LANGLE);
	            this.state = 1052;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===1 || ((((_la - 73)) & ~0x1f) === 0 && ((1 << (_la - 73)) & 10911) !== 0) || _la===105) {
	                this.state = 1051;
	                localctx._type_ = this.type_();
	                localctx.types.push(localctx._type_);
	            }

	            this.state = 1058;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(_la===102) {
	                this.state = 1054;
	                this.match(graphParser.TypeOr);
	                this.state = 1055;
	                localctx._type_ = this.type_();
	                localctx.types.push(localctx._type_);
	                this.state = 1060;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }
	            this.state = 1061;
	            this.match(graphParser.RANGLE);
	            break;
	        case 1:
	            localctx = new StringLiteralTypeContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 1062;
	            localctx.value = this.match(graphParser.StringLiteral);
	            break;
	        case 105:
	            localctx = new TypeReferenceContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 1063;
	            this.typeAlias();
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	        this._ctx.stop = this._input.LT(-1);
	        this.state = 1074;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,107,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                if(this._parseListeners!==null) {
	                    this.triggerExitRuleEvent();
	                }
	                _prevctx = localctx;
	                localctx = new ArrayTypeContext(this, new NonNullableTypeContext(this, _parentctx, _parentState));
	                this.pushNewRecursionContext(localctx, _startState, graphParser.RULE_nonNullableType);
	                this.state = 1066;
	                if (!( this.precpred(this._ctx, 5))) {
	                    throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 5)");
	                }
	                this.state = 1068;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	                if(_la===92) {
	                    this.state = 1067;
	                    localctx.nullable = this.match(graphParser.QMARK);
	                }

	                this.state = 1070;
	                this.match(graphParser.LBRACKET);
	                this.state = 1071;
	                this.match(graphParser.RBRACKET); 
	            }
	            this.state = 1076;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,107,this._ctx);
	        }

	    } catch( error) {
	        if(error instanceof antlr4.error.RecognitionException) {
		        localctx.exception = error;
		        this._errHandler.reportError(this, error);
		        this._errHandler.recover(this, error);
		    } else {
		    	throw error;
		    }
	    } finally {
	        this.unrollRecursionContexts(_parentctx)
	    }
	    return localctx;
	}



	predefinedType() {
	    let localctx = new PredefinedTypeContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 184, graphParser.RULE_predefinedType);
	    try {
	        this.state = 1082;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 77:
	            localctx = new UnknownTypeContext(this, localctx);
	            this.enterOuterAlt(localctx, 1);
	            this.state = 1077;
	            this.match(graphParser.Unknown);
	            break;
	        case 74:
	            localctx = new NumberTypeContext(this, localctx);
	            this.enterOuterAlt(localctx, 2);
	            this.state = 1078;
	            this.match(graphParser.Number);
	            break;
	        case 75:
	            localctx = new BooleanTypeContext(this, localctx);
	            this.enterOuterAlt(localctx, 3);
	            this.state = 1079;
	            this.match(graphParser.Boolean);
	            break;
	        case 76:
	            localctx = new StringTypeContext(this, localctx);
	            this.enterOuterAlt(localctx, 4);
	            this.state = 1080;
	            this.match(graphParser.String);
	            break;
	        case 73:
	            localctx = new EmptyTypeContext(this, localctx);
	            this.enterOuterAlt(localctx, 5);
	            this.state = 1081;
	            this.match(graphParser.Empty);
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	propertySignature() {
	    let localctx = new PropertySignatureContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 186, graphParser.RULE_propertySignature);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 1084;
	        this.propertyName();
	        this.state = 1086;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===92) {
	            this.state = 1085;
	            this.match(graphParser.QMARK);
	        }

	        this.state = 1088;
	        this.typeAnnotation();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	indexSignature() {
	    let localctx = new IndexSignatureContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 188, graphParser.RULE_indexSignature);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 1090;
	        this.match(graphParser.LBRACKET);
	        this.state = 1091;
	        this.match(graphParser.ID);
	        this.state = 1092;
	        this.match(graphParser.COLON);
	        this.state = 1093;
	        this.match(graphParser.String);
	        this.state = 1094;
	        this.match(graphParser.RBRACKET);
	        this.state = 1095;
	        this.typeAnnotation();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	typeAnnotation() {
	    let localctx = new TypeAnnotationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 190, graphParser.RULE_typeAnnotation);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 1097;
	        this.match(graphParser.COLON);
	        this.state = 1098;
	        this.type_();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	typeAlias() {
	    let localctx = new TypeAliasContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 192, graphParser.RULE_typeAlias);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 1100;
	        this.match(graphParser.ID);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


}

graphParser.EOF = antlr4.Token.EOF;
graphParser.StringLiteral = 1;
graphParser.PLUS = 2;
graphParser.MINUS = 3;
graphParser.STAR = 4;
graphParser.SLASH = 5;
graphParser.PERCENT = 6;
graphParser.APPLY = 7;
graphParser.WITH = 8;
graphParser.AS = 9;
graphParser.ASYNC = 10;
graphParser.BLOCK = 11;
graphParser.BLOCKCALL = 12;
graphParser.CATCH = 13;
graphParser.COMMENT = 14;
graphParser.CONDITIONS = 15;
graphParser.CONFIDENT = 16;
graphParser.CONTEXT = 17;
graphParser.COW = 18;
graphParser.DEFAULT = 19;
graphParser.DEFINED = 20;
graphParser.DIGRESSION = 21;
graphParser.DIGRESSIONS = 22;
graphParser.DISABLE = 23;
graphParser.DO = 24;
graphParser.DONE = 25;
graphParser.ELSE = 26;
graphParser.ENABLE = 27;
graphParser.EXTERNAL = 28;
graphParser.EXIT = 29;
graphParser.FINALLY = 30;
graphParser.FOR = 31;
graphParser.FUNCTION = 32;
graphParser.GLOBAL = 33;
graphParser.GOTO = 34;
graphParser.IF = 35;
graphParser.IMPORT = 36;
graphParser.IN = 37;
graphParser.INPUT = 38;
graphParser.IS = 39;
graphParser.LIBRARY = 40;
graphParser.LOGEXPR = 41;
graphParser.NODE = 42;
graphParser.NOT = 43;
graphParser.OF = 44;
graphParser.ON = 45;
graphParser.ONDIGRETURN = 46;
graphParser.ONEXIT = 47;
graphParser.OUTPUT = 48;
graphParser.PREPROCESSOR = 49;
graphParser.PRIORITY = 50;
graphParser.RETURN = 51;
graphParser.SAVE = 52;
graphParser.SET = 53;
graphParser.SHARED = 54;
graphParser.START = 55;
graphParser.STATIC = 56;
graphParser.SYNC = 57;
graphParser.SYSTEM = 58;
graphParser.TIMEOUT = 59;
graphParser.TRANSITIONS = 60;
graphParser.TAGS = 61;
graphParser.TRY = 62;
graphParser.TYPE = 63;
graphParser.VAR = 64;
graphParser.WAIT = 65;
graphParser.WHEN = 66;
graphParser.FILL = 67;
graphParser.BuiltinMark = 68;
graphParser.ContextMark = 69;
graphParser.DecimalLiteral = 70;
graphParser.DecimalIntegerLiteral = 71;
graphParser.BooleanLiteral = 72;
graphParser.Empty = 73;
graphParser.Number = 74;
graphParser.Boolean = 75;
graphParser.String = 76;
graphParser.Unknown = 77;
graphParser.NULL = 78;
graphParser.RBRACKET = 79;
graphParser.LBRACKET = 80;
graphParser.RANGLE = 81;
graphParser.LANGLE = 82;
graphParser.RPAREN = 83;
graphParser.LPAREN = 84;
graphParser.RCURL = 85;
graphParser.LCURL = 86;
graphParser.QUOTE = 87;
graphParser.BACKTRICK = 88;
graphParser.COLON = 89;
graphParser.SEMICOLON = 90;
graphParser.COMMA = 91;
graphParser.QMARK = 92;
graphParser.PERIOD = 93;
graphParser.EQUALSIGN = 94;
graphParser.AddOp = 95;
graphParser.RemoveOp = 96;
graphParser.EqualOp = 97;
graphParser.NotEqualOp = 98;
graphParser.GreaterEqualOp = 99;
graphParser.LessEqualOp = 100;
graphParser.OrOp = 101;
graphParser.TypeOr = 102;
graphParser.AndOp = 103;
graphParser.NotOperator = 104;
graphParser.ID = 105;
graphParser.LineComment = 106;
graphParser.DocsComment = 107;
graphParser.BlockComment = 108;
graphParser.Whitespace = 109;

graphParser.RULE_file = 0;
graphParser.RULE_referenceFile = 1;
graphParser.RULE_expressionFile = 2;
graphParser.RULE_blockContent = 3;
graphParser.RULE_systemDescription = 4;
graphParser.RULE_systemElementDescription = 5;
graphParser.RULE_contextDescription = 6;
graphParser.RULE_contextElementDescription = 7;
graphParser.RULE_externalFunctionDeclaration = 8;
graphParser.RULE_importDefinition = 9;
graphParser.RULE_whenDescription = 10;
graphParser.RULE_typeDefinition = 11;
graphParser.RULE_functionDescription = 12;
graphParser.RULE_contextFunctionDescription = 13;
graphParser.RULE_blockDeclaration = 14;
graphParser.RULE_nodeDeclaration = 15;
graphParser.RULE_digressionDeclaration = 16;
graphParser.RULE_digressionContent = 17;
graphParser.RULE_comment = 18;
graphParser.RULE_nodeContent = 19;
graphParser.RULE_nodeOnExitSection = 20;
graphParser.RULE_nodeOnExitSectionItem = 21;
graphParser.RULE_onExitDoWithConfident = 22;
graphParser.RULE_nodeOnDigressionReturnSection = 23;
graphParser.RULE_nodeTransitionSection = 24;
graphParser.RULE_namedTransitionDefinition = 25;
graphParser.RULE_transitionDefinition = 26;
graphParser.RULE_transitionDefinitionOnMessage = 27;
graphParser.RULE_timeoutTransitionDefinition = 28;
graphParser.RULE_conditionalTransitionDefinition = 29;
graphParser.RULE_unconditionalTransitionDefinition = 30;
graphParser.RULE_doSection = 31;
graphParser.RULE_blockBody = 32;
graphParser.RULE_oneOrGroupedCommand = 33;
graphParser.RULE_nodeCommand = 34;
graphParser.RULE_cycleCommand = 35;
graphParser.RULE_statement = 36;
graphParser.RULE_statementBody = 37;
graphParser.RULE_logExpressionTypeCommand = 38;
graphParser.RULE_digressionControl = 39;
graphParser.RULE_digressionSpec = 40;
graphParser.RULE_exitCommand = 41;
graphParser.RULE_returnCommand = 42;
graphParser.RULE_variableDefinition = 43;
graphParser.RULE_variableDeclaration = 44;
graphParser.RULE_typeDescription = 45;
graphParser.RULE_conditionalCommand = 46;
graphParser.RULE_foreachCommand = 47;
graphParser.RULE_waitCommand = 48;
graphParser.RULE_activatedTransitionList = 49;
graphParser.RULE_gotoCommand = 50;
graphParser.RULE_setCommand = 51;
graphParser.RULE_assignOpCommand = 52;
graphParser.RULE_lValue = 53;
graphParser.RULE_expression = 54;
graphParser.RULE_objectPropertyExpressionPart = 55;
graphParser.RULE_externalFunctionCall = 56;
graphParser.RULE_blockFunctionCall = 57;
graphParser.RULE_slotFillingCall = 58;
graphParser.RULE_builtinFunctionCall = 59;
graphParser.RULE_argumentInvokation = 60;
graphParser.RULE_argumentList = 61;
graphParser.RULE_namedArgumentList = 62;
graphParser.RULE_positionalArgumentList = 63;
graphParser.RULE_positionalArgument = 64;
graphParser.RULE_namedArgument = 65;
graphParser.RULE_parameterList = 66;
graphParser.RULE_parameter = 67;
graphParser.RULE_reference = 68;
graphParser.RULE_whenId = 69;
graphParser.RULE_nodeId = 70;
graphParser.RULE_blockId = 71;
graphParser.RULE_digressionId = 72;
graphParser.RULE_transitionName = 73;
graphParser.RULE_referenceName = 74;
graphParser.RULE_memberName = 75;
graphParser.RULE_tagName = 76;
graphParser.RULE_factName = 77;
graphParser.RULE_fieldName = 78;
graphParser.RULE_variableName = 79;
graphParser.RULE_argumentName = 80;
graphParser.RULE_parameterName = 81;
graphParser.RULE_propertyName = 82;
graphParser.RULE_builtinFunctionName = 83;
graphParser.RULE_externalFunctionName = 84;
graphParser.RULE_functionName = 85;
graphParser.RULE_anyNumber = 86;
graphParser.RULE_typeEof = 87;
graphParser.RULE_type_ = 88;
graphParser.RULE_questionMarkOptional = 89;
graphParser.RULE_objectTypeElementSeparator = 90;
graphParser.RULE_nonNullableType = 91;
graphParser.RULE_predefinedType = 92;
graphParser.RULE_propertySignature = 93;
graphParser.RULE_indexSignature = 94;
graphParser.RULE_typeAnnotation = 95;
graphParser.RULE_typeAlias = 96;

class FileContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_file;
        this.mainBlock = null;
    }

	EOF() {
	    return this.getToken(graphParser.EOF, 0);
	};

	blockContent() {
	    return this.getTypedRuleContext(BlockContentContext,0);
	};

	LIBRARY() {
	    return this.getToken(graphParser.LIBRARY, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterFile(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitFile(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitFile(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ReferenceFileContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_referenceFile;
    }

	reference() {
	    return this.getTypedRuleContext(ReferenceContext,0);
	};

	EOF() {
	    return this.getToken(graphParser.EOF, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterReferenceFile(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitReferenceFile(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitReferenceFile(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ExpressionFileContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_expressionFile;
    }

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	EOF() {
	    return this.getToken(graphParser.EOF, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterExpressionFile(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitExpressionFile(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitExpressionFile(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class BlockContentContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_blockContent;
        this._importDefinition = null;
        this.imports = [];
        this._typeDefinition = null;
        this.types = [];
        this.contextType = null;
        this.system = null;
        this._externalFunctionDeclaration = null;
        this.externalFunctions = [];
        this._nodeDeclaration = null;
        this.nodes = [];
        this._blockDeclaration = null;
        this.blocks = [];
        this._digressionDeclaration = null;
        this.digressions = [];
        this._contextFunctionDescription = null;
        this.contextFunctions = [];
        this._whenDescription = null;
        this.whenDescriptions = [];
    }

	CONTEXT() {
	    return this.getToken(graphParser.CONTEXT, 0);
	};

	SYSTEM() {
	    return this.getToken(graphParser.SYSTEM, 0);
	};

	importDefinition = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ImportDefinitionContext);
	    } else {
	        return this.getTypedRuleContext(ImportDefinitionContext,i);
	    }
	};

	typeDefinition = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(TypeDefinitionContext);
	    } else {
	        return this.getTypedRuleContext(TypeDefinitionContext,i);
	    }
	};

	contextDescription() {
	    return this.getTypedRuleContext(ContextDescriptionContext,0);
	};

	systemDescription() {
	    return this.getTypedRuleContext(SystemDescriptionContext,0);
	};

	externalFunctionDeclaration = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExternalFunctionDeclarationContext);
	    } else {
	        return this.getTypedRuleContext(ExternalFunctionDeclarationContext,i);
	    }
	};

	nodeDeclaration = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(NodeDeclarationContext);
	    } else {
	        return this.getTypedRuleContext(NodeDeclarationContext,i);
	    }
	};

	blockDeclaration = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(BlockDeclarationContext);
	    } else {
	        return this.getTypedRuleContext(BlockDeclarationContext,i);
	    }
	};

	digressionDeclaration = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(DigressionDeclarationContext);
	    } else {
	        return this.getTypedRuleContext(DigressionDeclarationContext,i);
	    }
	};

	contextFunctionDescription = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ContextFunctionDescriptionContext);
	    } else {
	        return this.getTypedRuleContext(ContextFunctionDescriptionContext,i);
	    }
	};

	whenDescription = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(WhenDescriptionContext);
	    } else {
	        return this.getTypedRuleContext(WhenDescriptionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBlockContent(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBlockContent(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBlockContent(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class SystemDescriptionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_systemDescription;
        this._systemElementDescription = null;
        this.elements = [];
    }

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	objectTypeElementSeparator = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ObjectTypeElementSeparatorContext);
	    } else {
	        return this.getTypedRuleContext(ObjectTypeElementSeparatorContext,i);
	    }
	};

	systemElementDescription = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(SystemElementDescriptionContext);
	    } else {
	        return this.getTypedRuleContext(SystemElementDescriptionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterSystemDescription(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitSystemDescription(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitSystemDescription(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class SystemElementDescriptionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_systemElementDescription;
        this.name = null;
        this.value = null;
    }

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	variableName() {
	    return this.getTypedRuleContext(VariableNameContext,0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	EQUALSIGN() {
	    return this.getToken(graphParser.EQUALSIGN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterSystemElementDescription(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitSystemElementDescription(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitSystemElementDescription(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ContextDescriptionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_contextDescription;
        this._contextElementDescription = null;
        this.elements = [];
    }

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	objectTypeElementSeparator = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ObjectTypeElementSeparatorContext);
	    } else {
	        return this.getTypedRuleContext(ObjectTypeElementSeparatorContext,i);
	    }
	};

	contextElementDescription = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ContextElementDescriptionContext);
	    } else {
	        return this.getTypedRuleContext(ContextElementDescriptionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterContextDescription(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitContextDescription(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitContextDescription(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ContextElementDescriptionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_contextElementDescription;
        this.input = null;
        this.output = null;
        this.name = null;
        this.type = null;
        this.value = null;
    }

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	variableName() {
	    return this.getTypedRuleContext(VariableNameContext,0);
	};

	typeDescription() {
	    return this.getTypedRuleContext(TypeDescriptionContext,0);
	};

	EQUALSIGN() {
	    return this.getToken(graphParser.EQUALSIGN, 0);
	};

	INPUT() {
	    return this.getToken(graphParser.INPUT, 0);
	};

	OUTPUT() {
	    return this.getToken(graphParser.OUTPUT, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterContextElementDescription(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitContextElementDescription(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitContextElementDescription(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ExternalFunctionDeclarationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_externalFunctionDeclaration;
        this.name = null;
        this.parameters = null;
        this.returnType = null;
    }

	EXTERNAL() {
	    return this.getToken(graphParser.EXTERNAL, 0);
	};

	FUNCTION() {
	    return this.getToken(graphParser.FUNCTION, 0);
	};

	LPAREN() {
	    return this.getToken(graphParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(graphParser.RPAREN, 0);
	};

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	SEMICOLON() {
	    return this.getToken(graphParser.SEMICOLON, 0);
	};

	externalFunctionName() {
	    return this.getTypedRuleContext(ExternalFunctionNameContext,0);
	};

	parameterList() {
	    return this.getTypedRuleContext(ParameterListContext,0);
	};

	typeDescription() {
	    return this.getTypedRuleContext(TypeDescriptionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterExternalFunctionDeclaration(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitExternalFunctionDeclaration(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitExternalFunctionDeclaration(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ImportDefinitionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_importDefinition;
        this.path = null;
    }

	IMPORT() {
	    return this.getToken(graphParser.IMPORT, 0);
	};

	SEMICOLON() {
	    return this.getToken(graphParser.SEMICOLON, 0);
	};

	StringLiteral() {
	    return this.getToken(graphParser.StringLiteral, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterImportDefinition(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitImportDefinition(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitImportDefinition(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class WhenDescriptionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_whenDescription;
        this.event = null;
        this.name = null;
        this.priority = null;
        this.doSec = null;
    }

	WHEN() {
	    return this.getToken(graphParser.WHEN, 0);
	};

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	doSection() {
	    return this.getTypedRuleContext(DoSectionContext,0);
	};

	PRIORITY() {
	    return this.getToken(graphParser.PRIORITY, 0);
	};

	whenId() {
	    return this.getTypedRuleContext(WhenIdContext,0);
	};

	DecimalIntegerLiteral() {
	    return this.getToken(graphParser.DecimalIntegerLiteral, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterWhenDescription(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitWhenDescription(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitWhenDescription(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TypeDefinitionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_typeDefinition;
        this._functionDescription = null;
        this.functions = [];
    }

	TYPE() {
	    return this.getToken(graphParser.TYPE, 0);
	};

	typeAlias() {
	    return this.getTypedRuleContext(TypeAliasContext,0);
	};

	EQUALSIGN() {
	    return this.getToken(graphParser.EQUALSIGN, 0);
	};

	typeDescription() {
	    return this.getTypedRuleContext(TypeDescriptionContext,0);
	};

	SEMICOLON() {
	    return this.getToken(graphParser.SEMICOLON, 0);
	};

	WITH() {
	    return this.getToken(graphParser.WITH, 0);
	};

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	functionDescription = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(FunctionDescriptionContext);
	    } else {
	        return this.getTypedRuleContext(FunctionDescriptionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTypeDefinition(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTypeDefinition(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTypeDefinition(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class FunctionDescriptionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_functionDescription;
        this._LineComment = null;
        this.comments = [];
        this.doc = null;
        this.name = null;
        this.parameters = null;
        this.returnType = null;
        this.body = null;
    }

	LPAREN() {
	    return this.getToken(graphParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(graphParser.RPAREN, 0);
	};

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	functionName() {
	    return this.getTypedRuleContext(FunctionNameContext,0);
	};

	parameterList() {
	    return this.getTypedRuleContext(ParameterListContext,0);
	};

	typeDescription() {
	    return this.getTypedRuleContext(TypeDescriptionContext,0);
	};

	blockBody() {
	    return this.getTypedRuleContext(BlockBodyContext,0);
	};

	DocsComment() {
	    return this.getToken(graphParser.DocsComment, 0);
	};

	BlockComment = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.BlockComment);
	    } else {
	        return this.getToken(graphParser.BlockComment, i);
	    }
	};


	LineComment = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.LineComment);
	    } else {
	        return this.getToken(graphParser.LineComment, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterFunctionDescription(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitFunctionDescription(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitFunctionDescription(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ContextFunctionDescriptionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_contextFunctionDescription;
        this._LineComment = null;
        this.comments = [];
        this.doc = null;
        this.name = null;
        this.parameters = null;
        this.returnType = null;
        this.body = null;
    }

	FUNCTION() {
	    return this.getToken(graphParser.FUNCTION, 0);
	};

	LPAREN() {
	    return this.getToken(graphParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(graphParser.RPAREN, 0);
	};

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	functionName() {
	    return this.getTypedRuleContext(FunctionNameContext,0);
	};

	parameterList() {
	    return this.getTypedRuleContext(ParameterListContext,0);
	};

	typeDescription() {
	    return this.getTypedRuleContext(TypeDescriptionContext,0);
	};

	blockBody() {
	    return this.getTypedRuleContext(BlockBodyContext,0);
	};

	DocsComment() {
	    return this.getToken(graphParser.DocsComment, 0);
	};

	BlockComment = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.BlockComment);
	    } else {
	        return this.getToken(graphParser.BlockComment, i);
	    }
	};


	LineComment = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.LineComment);
	    } else {
	        return this.getToken(graphParser.LineComment, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterContextFunctionDescription(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitContextFunctionDescription(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitContextFunctionDescription(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class BlockDeclarationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_blockDeclaration;
        this.sync = null;
        this.returnType = null;
        this.async = null;
        this.content = null;
    }

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	blockContent() {
	    return this.getTypedRuleContext(BlockContentContext,0);
	};

	BLOCK() {
	    return this.getToken(graphParser.BLOCK, 0);
	};

	blockId() {
	    return this.getTypedRuleContext(BlockIdContext,0);
	};

	LPAREN() {
	    return this.getToken(graphParser.LPAREN, 0);
	};

	parameterList() {
	    return this.getTypedRuleContext(ParameterListContext,0);
	};

	RPAREN() {
	    return this.getToken(graphParser.RPAREN, 0);
	};

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	typeDescription() {
	    return this.getTypedRuleContext(TypeDescriptionContext,0);
	};

	SYNC() {
	    return this.getToken(graphParser.SYNC, 0);
	};

	ASYNC() {
	    return this.getToken(graphParser.ASYNC, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBlockDeclaration(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBlockDeclaration(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBlockDeclaration(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NodeDeclarationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_nodeDeclaration;
        this.start = null;
        this.name = null;
        this.content = null;
    }

	NODE() {
	    return this.getToken(graphParser.NODE, 0);
	};

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	nodeId() {
	    return this.getTypedRuleContext(NodeIdContext,0);
	};

	nodeContent() {
	    return this.getTypedRuleContext(NodeContentContext,0);
	};

	comment() {
	    return this.getTypedRuleContext(CommentContext,0);
	};

	START() {
	    return this.getToken(graphParser.START, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNodeDeclaration(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNodeDeclaration(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNodeDeclaration(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class DigressionDeclarationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_digressionDeclaration;
        this.global = null;
        this.preprocessor = null;
        this.name = null;
    }

	DIGRESSION() {
	    return this.getToken(graphParser.DIGRESSION, 0);
	};

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	digressionContent() {
	    return this.getTypedRuleContext(DigressionContentContext,0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	digressionId() {
	    return this.getTypedRuleContext(DigressionIdContext,0);
	};

	GLOBAL() {
	    return this.getToken(graphParser.GLOBAL, 0);
	};

	PREPROCESSOR() {
	    return this.getToken(graphParser.PREPROCESSOR, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterDigressionDeclaration(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitDigressionDeclaration(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitDigressionDeclaration(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class DigressionContentContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_digressionContent;
        this._transitionDefinitionOnMessage = null;
        this.transitions = [];
        this._variableDefinition = null;
        this.sharedState = [];
        this.copiedState = [];
    }

	CONDITIONS() {
	    return this.getToken(graphParser.CONDITIONS, 0);
	};

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	nodeContent() {
	    return this.getTypedRuleContext(NodeContentContext,0);
	};

	SEMICOLON = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.SEMICOLON);
	    } else {
	        return this.getToken(graphParser.SEMICOLON, i);
	    }
	};


	transitionDefinitionOnMessage = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(TransitionDefinitionOnMessageContext);
	    } else {
	        return this.getTypedRuleContext(TransitionDefinitionOnMessageContext,i);
	    }
	};

	SHARED = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.SHARED);
	    } else {
	        return this.getToken(graphParser.SHARED, i);
	    }
	};


	variableDefinition = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(VariableDefinitionContext);
	    } else {
	        return this.getTypedRuleContext(VariableDefinitionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterDigressionContent(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitDigressionContent(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitDigressionContent(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class CommentContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_comment;
    }

	COMMENT() {
	    return this.getToken(graphParser.COMMENT, 0);
	};

	StringLiteral() {
	    return this.getToken(graphParser.StringLiteral, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterComment(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitComment(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitComment(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NodeContentContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_nodeContent;
        this.doSec = null;
        this.transitions = null;
        this.preExit = null;
        this.onExit = null;
    }

	doSection = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(DoSectionContext);
	    } else {
	        return this.getTypedRuleContext(DoSectionContext,i);
	    }
	};

	PREPROCESSOR() {
	    return this.getToken(graphParser.PREPROCESSOR, 0);
	};

	nodeOnDigressionReturnSection() {
	    return this.getTypedRuleContext(NodeOnDigressionReturnSectionContext,0);
	};

	nodeTransitionSection() {
	    return this.getTypedRuleContext(NodeTransitionSectionContext,0);
	};

	nodeOnExitSection() {
	    return this.getTypedRuleContext(NodeOnExitSectionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNodeContent(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNodeContent(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNodeContent(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NodeOnExitSectionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_nodeOnExitSection;
        this.defaultDo = null;
        this.digressionDo = null;
    }

	ONEXIT() {
	    return this.getToken(graphParser.ONEXIT, 0);
	};

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	nodeOnExitSectionItem = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(NodeOnExitSectionItemContext);
	    } else {
	        return this.getTypedRuleContext(NodeOnExitSectionItemContext,i);
	    }
	};

	DEFAULT() {
	    return this.getToken(graphParser.DEFAULT, 0);
	};

	COLON = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COLON);
	    } else {
	        return this.getToken(graphParser.COLON, i);
	    }
	};


	DIGRESSION() {
	    return this.getToken(graphParser.DIGRESSION, 0);
	};

	onExitDoWithConfident = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(OnExitDoWithConfidentContext);
	    } else {
	        return this.getTypedRuleContext(OnExitDoWithConfidentContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNodeOnExitSection(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNodeOnExitSection(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNodeOnExitSection(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NodeOnExitSectionItemContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_nodeOnExitSectionItem;
    }

	onExitDoWithConfident() {
	    return this.getTypedRuleContext(OnExitDoWithConfidentContext,0);
	};

	transitionName = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(TransitionNameContext);
	    } else {
	        return this.getTypedRuleContext(TransitionNameContext,i);
	    }
	};

	COLON = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COLON);
	    } else {
	        return this.getToken(graphParser.COLON, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNodeOnExitSectionItem(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNodeOnExitSectionItem(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNodeOnExitSectionItem(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class OnExitDoWithConfidentContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_onExitDoWithConfident;
        this.doSec = null;
        this.confidentDo = null;
    }

	doSection = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(DoSectionContext);
	    } else {
	        return this.getTypedRuleContext(DoSectionContext,i);
	    }
	};

	ON() {
	    return this.getToken(graphParser.ON, 0);
	};

	CONFIDENT() {
	    return this.getToken(graphParser.CONFIDENT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterOnExitDoWithConfident(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitOnExitDoWithConfident(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitOnExitDoWithConfident(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NodeOnDigressionReturnSectionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_nodeOnDigressionReturnSection;
    }

	ONDIGRETURN() {
	    return this.getToken(graphParser.ONDIGRETURN, 0);
	};

	blockBody() {
	    return this.getTypedRuleContext(BlockBodyContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNodeOnDigressionReturnSection(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNodeOnDigressionReturnSection(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNodeOnDigressionReturnSection(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NodeTransitionSectionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_nodeTransitionSection;
        this._namedTransitionDefinition = null;
        this.list = [];
    }

	TRANSITIONS() {
	    return this.getToken(graphParser.TRANSITIONS, 0);
	};

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	namedTransitionDefinition = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(NamedTransitionDefinitionContext);
	    } else {
	        return this.getTypedRuleContext(NamedTransitionDefinitionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNodeTransitionSection(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNodeTransitionSection(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNodeTransitionSection(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NamedTransitionDefinitionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_namedTransitionDefinition;
        this.target = null;
    }

	transitionName() {
	    return this.getTypedRuleContext(TransitionNameContext,0);
	};

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	GOTO() {
	    return this.getToken(graphParser.GOTO, 0);
	};

	transitionDefinition() {
	    return this.getTypedRuleContext(TransitionDefinitionContext,0);
	};

	SEMICOLON() {
	    return this.getToken(graphParser.SEMICOLON, 0);
	};

	nodeId() {
	    return this.getTypedRuleContext(NodeIdContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNamedTransitionDefinition(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNamedTransitionDefinition(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNamedTransitionDefinition(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TransitionDefinitionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_transitionDefinition;
    }

	transitionDefinitionOnMessage() {
	    return this.getTypedRuleContext(TransitionDefinitionOnMessageContext,0);
	};

	unconditionalTransitionDefinition() {
	    return this.getTypedRuleContext(UnconditionalTransitionDefinitionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTransitionDefinition(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTransitionDefinition(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTransitionDefinition(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TransitionDefinitionOnMessageContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_transitionDefinitionOnMessage;
    }

	conditionalTransitionDefinition() {
	    return this.getTypedRuleContext(ConditionalTransitionDefinitionContext,0);
	};

	timeoutTransitionDefinition() {
	    return this.getTypedRuleContext(TimeoutTransitionDefinitionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTransitionDefinitionOnMessage(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTransitionDefinitionOnMessage(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTransitionDefinitionOnMessage(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TimeoutTransitionDefinitionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_timeoutTransitionDefinition;
        this.timeout = null;
    }

	ON() {
	    return this.getToken(graphParser.ON, 0);
	};

	TIMEOUT() {
	    return this.getToken(graphParser.TIMEOUT, 0);
	};

	anyNumber() {
	    return this.getTypedRuleContext(AnyNumberContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTimeoutTransitionDefinition(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTimeoutTransitionDefinition(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTimeoutTransitionDefinition(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ConditionalTransitionDefinitionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_conditionalTransitionDefinition;
        this.condition = null;
        this.priority = null;
        this.confident = null;
        this._tagName = null;
        this.tags = [];
    }

	ON() {
	    return this.getToken(graphParser.ON, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	PRIORITY() {
	    return this.getToken(graphParser.PRIORITY, 0);
	};

	WHEN() {
	    return this.getToken(graphParser.WHEN, 0);
	};

	TAGS() {
	    return this.getToken(graphParser.TAGS, 0);
	};

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	DecimalIntegerLiteral() {
	    return this.getToken(graphParser.DecimalIntegerLiteral, 0);
	};

	CONFIDENT() {
	    return this.getToken(graphParser.CONFIDENT, 0);
	};

	tagName = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(TagNameContext);
	    } else {
	        return this.getTypedRuleContext(TagNameContext,i);
	    }
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COMMA);
	    } else {
	        return this.getToken(graphParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterConditionalTransitionDefinition(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitConditionalTransitionDefinition(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitConditionalTransitionDefinition(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class UnconditionalTransitionDefinitionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_unconditionalTransitionDefinition;
    }


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterUnconditionalTransitionDefinition(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitUnconditionalTransitionDefinition(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitUnconditionalTransitionDefinition(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class DoSectionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_doSection;
    }

	DO() {
	    return this.getToken(graphParser.DO, 0);
	};

	blockBody() {
	    return this.getTypedRuleContext(BlockBodyContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterDoSection(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitDoSection(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitDoSection(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class BlockBodyContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_blockBody;
        this._oneOrGroupedCommand = null;
        this.commands = [];
    }

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	oneOrGroupedCommand = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(OneOrGroupedCommandContext);
	    } else {
	        return this.getTypedRuleContext(OneOrGroupedCommandContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBlockBody(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBlockBody(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBlockBody(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class OneOrGroupedCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_oneOrGroupedCommand;
    }

	nodeCommand() {
	    return this.getTypedRuleContext(NodeCommandContext,0);
	};

	blockBody() {
	    return this.getTypedRuleContext(BlockBodyContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterOneOrGroupedCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitOneOrGroupedCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitOneOrGroupedCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NodeCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_nodeCommand;
    }

	statement() {
	    return this.getTypedRuleContext(StatementContext,0);
	};

	conditionalCommand() {
	    return this.getTypedRuleContext(ConditionalCommandContext,0);
	};

	cycleCommand() {
	    return this.getTypedRuleContext(CycleCommandContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNodeCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNodeCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNodeCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class CycleCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_cycleCommand;
    }

	foreachCommand() {
	    return this.getTypedRuleContext(ForeachCommandContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterCycleCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitCycleCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitCycleCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class StatementContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_statement;
    }

	statementBody() {
	    return this.getTypedRuleContext(StatementBodyContext,0);
	};

	SEMICOLON() {
	    return this.getToken(graphParser.SEMICOLON, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterStatement(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitStatement(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitStatement(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class StatementBodyContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_statementBody;
    }

	waitCommand() {
	    return this.getTypedRuleContext(WaitCommandContext,0);
	};

	gotoCommand() {
	    return this.getTypedRuleContext(GotoCommandContext,0);
	};

	setCommand() {
	    return this.getTypedRuleContext(SetCommandContext,0);
	};

	returnCommand() {
	    return this.getTypedRuleContext(ReturnCommandContext,0);
	};

	exitCommand() {
	    return this.getTypedRuleContext(ExitCommandContext,0);
	};

	assignOpCommand() {
	    return this.getTypedRuleContext(AssignOpCommandContext,0);
	};

	variableDefinition() {
	    return this.getTypedRuleContext(VariableDefinitionContext,0);
	};

	logExpressionTypeCommand() {
	    return this.getTypedRuleContext(LogExpressionTypeCommandContext,0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterStatementBody(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitStatementBody(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitStatementBody(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class LogExpressionTypeCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_logExpressionTypeCommand;
    }

	LOGEXPR() {
	    return this.getToken(graphParser.LOGEXPR, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterLogExpressionTypeCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitLogExpressionTypeCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitLogExpressionTypeCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class DigressionControlContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_digressionControl;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class SaveDigressionContext extends DigressionControlContext {

    constructor(parser, ctx) {
        super(parser);
        this.spec = null;;
        super.copyFrom(ctx);
    }

	DIGRESSION() {
	    return this.getToken(graphParser.DIGRESSION, 0);
	};

	SAVE() {
	    return this.getToken(graphParser.SAVE, 0);
	};

	digressionSpec() {
	    return this.getTypedRuleContext(DigressionSpecContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterSaveDigression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitSaveDigression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitSaveDigression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.SaveDigressionContext = SaveDigressionContext;

class ApplyDigressionContext extends DigressionControlContext {

    constructor(parser, ctx) {
        super(parser);
        this.mask = null;;
        super.copyFrom(ctx);
    }

	DIGRESSION() {
	    return this.getToken(graphParser.DIGRESSION, 0);
	};

	APPLY() {
	    return this.getToken(graphParser.APPLY, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterApplyDigression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitApplyDigression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitApplyDigression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.ApplyDigressionContext = ApplyDigressionContext;

class EnableDigressionContext extends DigressionControlContext {

    constructor(parser, ctx) {
        super(parser);
        this.spec = null;;
        super.copyFrom(ctx);
    }

	DIGRESSION() {
	    return this.getToken(graphParser.DIGRESSION, 0);
	};

	ENABLE() {
	    return this.getToken(graphParser.ENABLE, 0);
	};

	digressionSpec() {
	    return this.getTypedRuleContext(DigressionSpecContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterEnableDigression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitEnableDigression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitEnableDigression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.EnableDigressionContext = EnableDigressionContext;

class DisableDigressionContext extends DigressionControlContext {

    constructor(parser, ctx) {
        super(parser);
        this.spec = null;;
        super.copyFrom(ctx);
    }

	DIGRESSION() {
	    return this.getToken(graphParser.DIGRESSION, 0);
	};

	DISABLE() {
	    return this.getToken(graphParser.DISABLE, 0);
	};

	digressionSpec() {
	    return this.getTypedRuleContext(DigressionSpecContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterDisableDigression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitDisableDigression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitDisableDigression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.DisableDigressionContext = DisableDigressionContext;

class DigressionSpecContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_digressionSpec;
        this._digressionId = null;
        this.list = [];
    }

	digressionId = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(DigressionIdContext);
	    } else {
	        return this.getTypedRuleContext(DigressionIdContext,i);
	    }
	};

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COMMA);
	    } else {
	        return this.getToken(graphParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterDigressionSpec(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitDigressionSpec(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitDigressionSpec(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ExitCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_exitCommand;
    }

	EXIT() {
	    return this.getToken(graphParser.EXIT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterExitCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitExitCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitExitCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ReturnCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_returnCommand;
        this.returnValue = null;
    }

	RETURN() {
	    return this.getToken(graphParser.RETURN, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterReturnCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitReturnCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitReturnCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class VariableDefinitionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_variableDefinition;
        this.type = null;
        this.value = null;
    }

	variableDeclaration() {
	    return this.getTypedRuleContext(VariableDeclarationContext,0);
	};

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	EQUALSIGN() {
	    return this.getToken(graphParser.EQUALSIGN, 0);
	};

	typeDescription() {
	    return this.getTypedRuleContext(TypeDescriptionContext,0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterVariableDefinition(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitVariableDefinition(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitVariableDefinition(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class VariableDeclarationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_variableDeclaration;
    }

	VAR() {
	    return this.getToken(graphParser.VAR, 0);
	};

	variableName() {
	    return this.getTypedRuleContext(VariableNameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterVariableDeclaration(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitVariableDeclaration(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitVariableDeclaration(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TypeDescriptionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_typeDescription;
    }

	type_() {
	    return this.getTypedRuleContext(Type_Context,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTypeDescription(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTypeDescription(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTypeDescription(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ConditionalCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_conditionalCommand;
        this.condition = null;
        this.thenCommand = null;
        this.elseCommand = null;
    }

	IF() {
	    return this.getToken(graphParser.IF, 0);
	};

	LPAREN() {
	    return this.getToken(graphParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(graphParser.RPAREN, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	oneOrGroupedCommand = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(OneOrGroupedCommandContext);
	    } else {
	        return this.getTypedRuleContext(OneOrGroupedCommandContext,i);
	    }
	};

	ELSE() {
	    return this.getToken(graphParser.ELSE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterConditionalCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitConditionalCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitConditionalCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ForeachCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_foreachCommand;
        this.container = null;
        this.body = null;
    }

	FOR() {
	    return this.getToken(graphParser.FOR, 0);
	};

	LPAREN() {
	    return this.getToken(graphParser.LPAREN, 0);
	};

	variableDeclaration() {
	    return this.getTypedRuleContext(VariableDeclarationContext,0);
	};

	IN() {
	    return this.getToken(graphParser.IN, 0);
	};

	RPAREN() {
	    return this.getToken(graphParser.RPAREN, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	oneOrGroupedCommand() {
	    return this.getTypedRuleContext(OneOrGroupedCommandContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterForeachCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitForeachCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitForeachCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class WaitCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_waitCommand;
    }

	WAIT() {
	    return this.getToken(graphParser.WAIT, 0);
	};

	activatedTransitionList() {
	    return this.getTypedRuleContext(ActivatedTransitionListContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterWaitCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitWaitCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitWaitCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ActivatedTransitionListContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_activatedTransitionList;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class SelectedActivatedTransitionListContext extends ActivatedTransitionListContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	transitionName = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(TransitionNameContext);
	    } else {
	        return this.getTypedRuleContext(TransitionNameContext,i);
	    }
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COMMA);
	    } else {
	        return this.getToken(graphParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterSelectedActivatedTransitionList(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitSelectedActivatedTransitionList(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitSelectedActivatedTransitionList(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.SelectedActivatedTransitionListContext = SelectedActivatedTransitionListContext;

class AllActivatedTransitionListContext extends ActivatedTransitionListContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	STAR() {
	    return this.getToken(graphParser.STAR, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterAllActivatedTransitionList(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitAllActivatedTransitionList(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitAllActivatedTransitionList(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.AllActivatedTransitionListContext = AllActivatedTransitionListContext;

class GotoCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_gotoCommand;
    }

	GOTO() {
	    return this.getToken(graphParser.GOTO, 0);
	};

	transitionName() {
	    return this.getTypedRuleContext(TransitionNameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterGotoCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitGotoCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitGotoCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class SetCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_setCommand;
        this.ref = null;
        this.rightPartExpression = null;
    }

	SET() {
	    return this.getToken(graphParser.SET, 0);
	};

	EQUALSIGN() {
	    return this.getToken(graphParser.EQUALSIGN, 0);
	};

	lValue() {
	    return this.getTypedRuleContext(LValueContext,0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterSetCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitSetCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitSetCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class AssignOpCommandContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_assignOpCommand;
        this.ref = null;
        this.op = null;
        this.rightPartExpression = null;
    }

	SET() {
	    return this.getToken(graphParser.SET, 0);
	};

	lValue() {
	    return this.getTypedRuleContext(LValueContext,0);
	};

	AddOp() {
	    return this.getToken(graphParser.AddOp, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	RemoveOp() {
	    return this.getToken(graphParser.RemoveOp, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterAssignOpCommand(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitAssignOpCommand(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitAssignOpCommand(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class LValueContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_lValue;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class LValueReferenceExpressionContext extends LValueContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	reference() {
	    return this.getTypedRuleContext(ReferenceContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterLValueReferenceExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitLValueReferenceExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitLValueReferenceExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.LValueReferenceExpressionContext = LValueReferenceExpressionContext;

class LValueParenthesizedExpressionContext extends LValueContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	LPAREN() {
	    return this.getToken(graphParser.LPAREN, 0);
	};

	lValue() {
	    return this.getTypedRuleContext(LValueContext,0);
	};

	RPAREN() {
	    return this.getToken(graphParser.RPAREN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterLValueParenthesizedExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitLValueParenthesizedExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitLValueParenthesizedExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.LValueParenthesizedExpressionContext = LValueParenthesizedExpressionContext;

class LValueDotAccessExpressionContext extends LValueContext {

    constructor(parser, ctx) {
        super(parser);
        this.parent = null;;
        this.member = null;;
        super.copyFrom(ctx);
    }

	PERIOD() {
	    return this.getToken(graphParser.PERIOD, 0);
	};

	lValue() {
	    return this.getTypedRuleContext(LValueContext,0);
	};

	memberName() {
	    return this.getTypedRuleContext(MemberNameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterLValueDotAccessExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitLValueDotAccessExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitLValueDotAccessExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.LValueDotAccessExpressionContext = LValueDotAccessExpressionContext;

class LValueLiteralIndexAccessExpressionContext extends LValueContext {

    constructor(parser, ctx) {
        super(parser);
        this.parent = null;;
        this.index = null;;
        super.copyFrom(ctx);
    }

	LBRACKET() {
	    return this.getToken(graphParser.LBRACKET, 0);
	};

	RBRACKET() {
	    return this.getToken(graphParser.RBRACKET, 0);
	};

	lValue() {
	    return this.getTypedRuleContext(LValueContext,0);
	};

	DecimalIntegerLiteral() {
	    return this.getToken(graphParser.DecimalIntegerLiteral, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterLValueLiteralIndexAccessExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitLValueLiteralIndexAccessExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitLValueLiteralIndexAccessExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.LValueLiteralIndexAccessExpressionContext = LValueLiteralIndexAccessExpressionContext;

class LValueExpressionIndexAccessExpressionContext extends LValueContext {

    constructor(parser, ctx) {
        super(parser);
        this.parent = null;;
        this.index = null;;
        super.copyFrom(ctx);
    }

	LBRACKET() {
	    return this.getToken(graphParser.LBRACKET, 0);
	};

	RBRACKET() {
	    return this.getToken(graphParser.RBRACKET, 0);
	};

	lValue() {
	    return this.getTypedRuleContext(LValueContext,0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterLValueExpressionIndexAccessExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitLValueExpressionIndexAccessExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitLValueExpressionIndexAccessExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.LValueExpressionIndexAccessExpressionContext = LValueExpressionIndexAccessExpressionContext;

class ExpressionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_expression;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class TernaryOpExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.condition = null;;
        this.thenExpression = null;;
        this.elseExpression = null;;
        super.copyFrom(ctx);
    }

	QMARK() {
	    return this.getToken(graphParser.QMARK, 0);
	};

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTernaryOpExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTernaryOpExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTernaryOpExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.TernaryOpExpressionContext = TernaryOpExpressionContext;

class ExpressionIndexAccessExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.parent = null;;
        this.index = null;;
        super.copyFrom(ctx);
    }

	LBRACKET() {
	    return this.getToken(graphParser.LBRACKET, 0);
	};

	RBRACKET() {
	    return this.getToken(graphParser.RBRACKET, 0);
	};

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterExpressionIndexAccessExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitExpressionIndexAccessExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitExpressionIndexAccessExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.ExpressionIndexAccessExpressionContext = ExpressionIndexAccessExpressionContext;

class NullCollateExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.nullable = null;;
        this.defaultValue = null;;
        super.copyFrom(ctx);
    }

	QMARK = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.QMARK);
	    } else {
	        return this.getToken(graphParser.QMARK, i);
	    }
	};


	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNullCollateExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNullCollateExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNullCollateExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.NullCollateExpressionContext = NullCollateExpressionContext;

class BooleanLiteralExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	BooleanLiteral() {
	    return this.getToken(graphParser.BooleanLiteral, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBooleanLiteralExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBooleanLiteralExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBooleanLiteralExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.BooleanLiteralExpressionContext = BooleanLiteralExpressionContext;

class NumberLiteralExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	anyNumber() {
	    return this.getTypedRuleContext(AnyNumberContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNumberLiteralExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNumberLiteralExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNumberLiteralExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.NumberLiteralExpressionContext = NumberLiteralExpressionContext;

class BinaryOpExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.left = null;;
        this.op = null;;
        this.right = null;;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	STAR() {
	    return this.getToken(graphParser.STAR, 0);
	};

	SLASH() {
	    return this.getToken(graphParser.SLASH, 0);
	};

	PERCENT() {
	    return this.getToken(graphParser.PERCENT, 0);
	};

	PLUS() {
	    return this.getToken(graphParser.PLUS, 0);
	};

	MINUS() {
	    return this.getToken(graphParser.MINUS, 0);
	};

	LANGLE() {
	    return this.getToken(graphParser.LANGLE, 0);
	};

	LessEqualOp() {
	    return this.getToken(graphParser.LessEqualOp, 0);
	};

	RANGLE() {
	    return this.getToken(graphParser.RANGLE, 0);
	};

	GreaterEqualOp() {
	    return this.getToken(graphParser.GreaterEqualOp, 0);
	};

	EqualOp() {
	    return this.getToken(graphParser.EqualOp, 0);
	};

	NotEqualOp() {
	    return this.getToken(graphParser.NotEqualOp, 0);
	};

	AndOp() {
	    return this.getToken(graphParser.AndOp, 0);
	};

	OrOp() {
	    return this.getToken(graphParser.OrOp, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBinaryOpExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBinaryOpExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBinaryOpExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.BinaryOpExpressionContext = BinaryOpExpressionContext;

class OptionalCallDotAccessExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.parent = null;;
        this.member = null;;
        this.arguments = null;;
        super.copyFrom(ctx);
    }

	QMARK() {
	    return this.getToken(graphParser.QMARK, 0);
	};

	PERIOD() {
	    return this.getToken(graphParser.PERIOD, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	memberName() {
	    return this.getTypedRuleContext(MemberNameContext,0);
	};

	argumentInvokation() {
	    return this.getTypedRuleContext(ArgumentInvokationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterOptionalCallDotAccessExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitOptionalCallDotAccessExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitOptionalCallDotAccessExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.OptionalCallDotAccessExpressionContext = OptionalCallDotAccessExpressionContext;

class CastExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	AS() {
	    return this.getToken(graphParser.AS, 0);
	};

	typeDescription() {
	    return this.getTypedRuleContext(TypeDescriptionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterCastExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitCastExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitCastExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.CastExpressionContext = CastExpressionContext;

class BuiltinFunctionCallExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	builtinFunctionCall() {
	    return this.getTypedRuleContext(BuiltinFunctionCallContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBuiltinFunctionCallExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBuiltinFunctionCallExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBuiltinFunctionCallExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.BuiltinFunctionCallExpressionContext = BuiltinFunctionCallExpressionContext;

class ParenthesizedExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	LPAREN() {
	    return this.getToken(graphParser.LPAREN, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	RPAREN() {
	    return this.getToken(graphParser.RPAREN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterParenthesizedExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitParenthesizedExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitParenthesizedExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.ParenthesizedExpressionContext = ParenthesizedExpressionContext;

class CallDotAccessExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.parent = null;;
        this.member = null;;
        this.arguments = null;;
        super.copyFrom(ctx);
    }

	PERIOD() {
	    return this.getToken(graphParser.PERIOD, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	memberName() {
	    return this.getTypedRuleContext(MemberNameContext,0);
	};

	argumentInvokation() {
	    return this.getTypedRuleContext(ArgumentInvokationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterCallDotAccessExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitCallDotAccessExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitCallDotAccessExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.CallDotAccessExpressionContext = CallDotAccessExpressionContext;

class NullLiteralExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	NULL() {
	    return this.getToken(graphParser.NULL, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNullLiteralExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNullLiteralExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNullLiteralExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.NullLiteralExpressionContext = NullLiteralExpressionContext;

class IsNullExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	IS() {
	    return this.getToken(graphParser.IS, 0);
	};

	NULL() {
	    return this.getToken(graphParser.NULL, 0);
	};

	NOT() {
	    return this.getToken(graphParser.NOT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterIsNullExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitIsNullExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitIsNullExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.IsNullExpressionContext = IsNullExpressionContext;

class DigressionControlExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	digressionControl() {
	    return this.getTypedRuleContext(DigressionControlContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterDigressionControlExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitDigressionControlExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitDigressionControlExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.DigressionControlExpressionContext = DigressionControlExpressionContext;

class TupleLiteralExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this._expression = null;;
        this.elements = [];;
        super.copyFrom(ctx);
    }

	LBRACKET() {
	    return this.getToken(graphParser.LBRACKET, 0);
	};

	RBRACKET() {
	    return this.getToken(graphParser.RBRACKET, 0);
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COMMA);
	    } else {
	        return this.getToken(graphParser.COMMA, i);
	    }
	};


	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTupleLiteralExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTupleLiteralExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTupleLiteralExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.TupleLiteralExpressionContext = TupleLiteralExpressionContext;

class BlockFunctionCallExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	blockFunctionCall() {
	    return this.getTypedRuleContext(BlockFunctionCallContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBlockFunctionCallExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBlockFunctionCallExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBlockFunctionCallExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.BlockFunctionCallExpressionContext = BlockFunctionCallExpressionContext;

class ReferenceExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	reference() {
	    return this.getTypedRuleContext(ReferenceContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterReferenceExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitReferenceExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitReferenceExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.ReferenceExpressionContext = ReferenceExpressionContext;

class OptionalDotAccessExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.parent = null;;
        this.member = null;;
        super.copyFrom(ctx);
    }

	QMARK() {
	    return this.getToken(graphParser.QMARK, 0);
	};

	PERIOD() {
	    return this.getToken(graphParser.PERIOD, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	memberName() {
	    return this.getTypedRuleContext(MemberNameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterOptionalDotAccessExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitOptionalDotAccessExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitOptionalDotAccessExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.OptionalDotAccessExpressionContext = OptionalDotAccessExpressionContext;

class ObjectLiteralExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this._objectPropertyExpressionPart = null;;
        this.fields = [];;
        super.copyFrom(ctx);
    }

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	objectPropertyExpressionPart = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ObjectPropertyExpressionPartContext);
	    } else {
	        return this.getTypedRuleContext(ObjectPropertyExpressionPartContext,i);
	    }
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COMMA);
	    } else {
	        return this.getToken(graphParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterObjectLiteralExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitObjectLiteralExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitObjectLiteralExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.ObjectLiteralExpressionContext = ObjectLiteralExpressionContext;

class LiteralIndexAccessExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.parent = null;;
        this.index = null;;
        super.copyFrom(ctx);
    }

	LBRACKET() {
	    return this.getToken(graphParser.LBRACKET, 0);
	};

	RBRACKET() {
	    return this.getToken(graphParser.RBRACKET, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	DecimalIntegerLiteral() {
	    return this.getToken(graphParser.DecimalIntegerLiteral, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterLiteralIndexAccessExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitLiteralIndexAccessExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitLiteralIndexAccessExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.LiteralIndexAccessExpressionContext = LiteralIndexAccessExpressionContext;

class ExternFunctionCallExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	externalFunctionCall() {
	    return this.getTypedRuleContext(ExternalFunctionCallContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterExternFunctionCallExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitExternFunctionCallExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitExternFunctionCallExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.ExternFunctionCallExpressionContext = ExternFunctionCallExpressionContext;

class StringLiteralExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	StringLiteral() {
	    return this.getToken(graphParser.StringLiteral, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterStringLiteralExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitStringLiteralExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitStringLiteralExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.StringLiteralExpressionContext = StringLiteralExpressionContext;

class SlotFillingCallExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	slotFillingCall() {
	    return this.getTypedRuleContext(SlotFillingCallContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterSlotFillingCallExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitSlotFillingCallExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitSlotFillingCallExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.SlotFillingCallExpressionContext = SlotFillingCallExpressionContext;

class IsDefinedExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	reference() {
	    return this.getTypedRuleContext(ReferenceContext,0);
	};

	IS() {
	    return this.getToken(graphParser.IS, 0);
	};

	DEFINED() {
	    return this.getToken(graphParser.DEFINED, 0);
	};

	NOT() {
	    return this.getToken(graphParser.NOT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterIsDefinedExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitIsDefinedExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitIsDefinedExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.IsDefinedExpressionContext = IsDefinedExpressionContext;

class UnaryOpExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.op = null;;
        super.copyFrom(ctx);
    }

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	PLUS() {
	    return this.getToken(graphParser.PLUS, 0);
	};

	MINUS() {
	    return this.getToken(graphParser.MINUS, 0);
	};

	NotOperator() {
	    return this.getToken(graphParser.NotOperator, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterUnaryOpExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitUnaryOpExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitUnaryOpExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.UnaryOpExpressionContext = UnaryOpExpressionContext;

class DotAccessExpressionContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.parent = null;;
        this.member = null;;
        super.copyFrom(ctx);
    }

	PERIOD() {
	    return this.getToken(graphParser.PERIOD, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	memberName() {
	    return this.getTypedRuleContext(MemberNameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterDotAccessExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitDotAccessExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitDotAccessExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.DotAccessExpressionContext = DotAccessExpressionContext;

class ObjectPropertyExpressionPartContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_objectPropertyExpressionPart;
        this.name = null;
    }

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	propertyName() {
	    return this.getTypedRuleContext(PropertyNameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterObjectPropertyExpressionPart(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitObjectPropertyExpressionPart(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitObjectPropertyExpressionPart(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ExternalFunctionCallContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_externalFunctionCall;
        this.name = null;
        this.arguments = null;
    }

	EXTERNAL() {
	    return this.getToken(graphParser.EXTERNAL, 0);
	};

	externalFunctionName() {
	    return this.getTypedRuleContext(ExternalFunctionNameContext,0);
	};

	argumentInvokation() {
	    return this.getTypedRuleContext(ArgumentInvokationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterExternalFunctionCall(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitExternalFunctionCall(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitExternalFunctionCall(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class BlockFunctionCallContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_blockFunctionCall;
        this.name = null;
        this.arguments = null;
    }

	BLOCKCALL() {
	    return this.getToken(graphParser.BLOCKCALL, 0);
	};

	blockId() {
	    return this.getTypedRuleContext(BlockIdContext,0);
	};

	argumentInvokation() {
	    return this.getTypedRuleContext(ArgumentInvokationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBlockFunctionCall(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBlockFunctionCall(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBlockFunctionCall(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class SlotFillingCallContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_slotFillingCall;
        this.name = null;
        this.arguments = null;
    }

	FILL() {
	    return this.getToken(graphParser.FILL, 0);
	};

	typeAlias() {
	    return this.getTypedRuleContext(TypeAliasContext,0);
	};

	argumentInvokation() {
	    return this.getTypedRuleContext(ArgumentInvokationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterSlotFillingCall(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitSlotFillingCall(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitSlotFillingCall(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class BuiltinFunctionCallContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_builtinFunctionCall;
        this.name = null;
        this.arguments = null;
    }

	BuiltinMark() {
	    return this.getToken(graphParser.BuiltinMark, 0);
	};

	builtinFunctionName() {
	    return this.getTypedRuleContext(BuiltinFunctionNameContext,0);
	};

	argumentInvokation() {
	    return this.getTypedRuleContext(ArgumentInvokationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBuiltinFunctionCall(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBuiltinFunctionCall(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBuiltinFunctionCall(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ArgumentInvokationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_argumentInvokation;
    }

	LPAREN() {
	    return this.getToken(graphParser.LPAREN, 0);
	};

	argumentList() {
	    return this.getTypedRuleContext(ArgumentListContext,0);
	};

	RPAREN() {
	    return this.getToken(graphParser.RPAREN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterArgumentInvokation(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitArgumentInvokation(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitArgumentInvokation(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ArgumentListContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_argumentList;
        this.positional = null;
        this.named = null;
    }

	positionalArgumentList() {
	    return this.getTypedRuleContext(PositionalArgumentListContext,0);
	};

	COMMA() {
	    return this.getToken(graphParser.COMMA, 0);
	};

	namedArgumentList() {
	    return this.getTypedRuleContext(NamedArgumentListContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterArgumentList(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitArgumentList(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitArgumentList(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NamedArgumentListContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_namedArgumentList;
        this._namedArgument = null;
        this.arguments = [];
    }

	namedArgument = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(NamedArgumentContext);
	    } else {
	        return this.getTypedRuleContext(NamedArgumentContext,i);
	    }
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COMMA);
	    } else {
	        return this.getToken(graphParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNamedArgumentList(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNamedArgumentList(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNamedArgumentList(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class PositionalArgumentListContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_positionalArgumentList;
        this._positionalArgument = null;
        this.arguments = [];
    }

	positionalArgument = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(PositionalArgumentContext);
	    } else {
	        return this.getTypedRuleContext(PositionalArgumentContext,i);
	    }
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COMMA);
	    } else {
	        return this.getToken(graphParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterPositionalArgumentList(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitPositionalArgumentList(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitPositionalArgumentList(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class PositionalArgumentContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_positionalArgument;
    }

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterPositionalArgument(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitPositionalArgument(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitPositionalArgument(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NamedArgumentContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_namedArgument;
    }

	argumentName() {
	    return this.getTypedRuleContext(ArgumentNameContext,0);
	};

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNamedArgument(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNamedArgument(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNamedArgument(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ParameterListContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_parameterList;
        this._parameter = null;
        this.parameters = [];
    }

	parameter = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ParameterContext);
	    } else {
	        return this.getTypedRuleContext(ParameterContext,i);
	    }
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COMMA);
	    } else {
	        return this.getToken(graphParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterParameterList(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitParameterList(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitParameterList(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ParameterContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_parameter;
        this.name = null;
        this.type = null;
        this.defaultValue = null;
    }

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	parameterName() {
	    return this.getTypedRuleContext(ParameterNameContext,0);
	};

	typeDescription() {
	    return this.getTypedRuleContext(TypeDescriptionContext,0);
	};

	EQUALSIGN() {
	    return this.getToken(graphParser.EQUALSIGN, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterParameter(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitParameter(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitParameter(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ReferenceContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_reference;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class LocalReferenceContext extends ReferenceContext {

    constructor(parser, ctx) {
        super(parser);
        this.refName = null;;
        super.copyFrom(ctx);
    }

	referenceName() {
	    return this.getTypedRuleContext(ReferenceNameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterLocalReference(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitLocalReference(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitLocalReference(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.LocalReferenceContext = LocalReferenceContext;

class DigressionReferenceContext extends ReferenceContext {

    constructor(parser, ctx) {
        super(parser);
        this.name = null;;
        this.shared = null;;
        this.refName = null;;
        super.copyFrom(ctx);
    }

	DIGRESSION() {
	    return this.getToken(graphParser.DIGRESSION, 0);
	};

	PERIOD = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.PERIOD);
	    } else {
	        return this.getToken(graphParser.PERIOD, i);
	    }
	};


	digressionId() {
	    return this.getTypedRuleContext(DigressionIdContext,0);
	};

	SHARED() {
	    return this.getToken(graphParser.SHARED, 0);
	};

	referenceName() {
	    return this.getTypedRuleContext(ReferenceNameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterDigressionReference(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitDigressionReference(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitDigressionReference(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.DigressionReferenceContext = DigressionReferenceContext;

class ContextReferenceContext extends ReferenceContext {

    constructor(parser, ctx) {
        super(parser);
        this.refName = null;;
        super.copyFrom(ctx);
    }

	ContextMark() {
	    return this.getToken(graphParser.ContextMark, 0);
	};

	referenceName() {
	    return this.getTypedRuleContext(ReferenceNameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterContextReference(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitContextReference(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitContextReference(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.ContextReferenceContext = ContextReferenceContext;

class BuiltinReferenceContext extends ReferenceContext {

    constructor(parser, ctx) {
        super(parser);
        this.refName = null;;
        super.copyFrom(ctx);
    }

	BuiltinMark() {
	    return this.getToken(graphParser.BuiltinMark, 0);
	};

	referenceName() {
	    return this.getTypedRuleContext(ReferenceNameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBuiltinReference(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBuiltinReference(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBuiltinReference(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.BuiltinReferenceContext = BuiltinReferenceContext;

class WhenIdContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_whenId;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterWhenId(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitWhenId(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitWhenId(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NodeIdContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_nodeId;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNodeId(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNodeId(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNodeId(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class BlockIdContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_blockId;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBlockId(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBlockId(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBlockId(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class DigressionIdContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_digressionId;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterDigressionId(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitDigressionId(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitDigressionId(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TransitionNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_transitionName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTransitionName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTransitionName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTransitionName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ReferenceNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_referenceName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterReferenceName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitReferenceName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitReferenceName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class MemberNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_memberName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterMemberName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitMemberName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitMemberName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TagNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_tagName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTagName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTagName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTagName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class FactNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_factName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterFactName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitFactName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitFactName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class FieldNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_fieldName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterFieldName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitFieldName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitFieldName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class VariableNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_variableName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterVariableName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitVariableName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitVariableName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ArgumentNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_argumentName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterArgumentName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitArgumentName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitArgumentName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ParameterNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_parameterName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterParameterName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitParameterName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitParameterName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class PropertyNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_propertyName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	StringLiteral() {
	    return this.getToken(graphParser.StringLiteral, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterPropertyName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitPropertyName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitPropertyName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class BuiltinFunctionNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_builtinFunctionName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBuiltinFunctionName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBuiltinFunctionName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBuiltinFunctionName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ExternalFunctionNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_externalFunctionName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterExternalFunctionName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitExternalFunctionName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitExternalFunctionName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class FunctionNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_functionName;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterFunctionName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitFunctionName(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitFunctionName(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class AnyNumberContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_anyNumber;
    }

	DecimalLiteral() {
	    return this.getToken(graphParser.DecimalLiteral, 0);
	};

	DecimalIntegerLiteral() {
	    return this.getToken(graphParser.DecimalIntegerLiteral, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterAnyNumber(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitAnyNumber(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitAnyNumber(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TypeEofContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_typeEof;
    }

	type_() {
	    return this.getTypedRuleContext(Type_Context,0);
	};

	EOF() {
	    return this.getToken(graphParser.EOF, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTypeEof(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTypeEof(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTypeEof(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class Type_Context extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_type_;
        this._nonNullableType = null;
        this.types = [];
        this._questionMarkOptional = null;
        this.nullableFlags = [];
    }

	nonNullableType = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(NonNullableTypeContext);
	    } else {
	        return this.getTypedRuleContext(NonNullableTypeContext,i);
	    }
	};

	questionMarkOptional = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(QuestionMarkOptionalContext);
	    } else {
	        return this.getTypedRuleContext(QuestionMarkOptionalContext,i);
	    }
	};

	TypeOr = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.TypeOr);
	    } else {
	        return this.getToken(graphParser.TypeOr, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterType_(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitType_(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitType_(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class QuestionMarkOptionalContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_questionMarkOptional;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class PresentQuestionMarkContext extends QuestionMarkOptionalContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	QMARK() {
	    return this.getToken(graphParser.QMARK, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterPresentQuestionMark(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitPresentQuestionMark(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitPresentQuestionMark(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.PresentQuestionMarkContext = PresentQuestionMarkContext;

class NoQuestionMarkContext extends QuestionMarkOptionalContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }


	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNoQuestionMark(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNoQuestionMark(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNoQuestionMark(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.NoQuestionMarkContext = NoQuestionMarkContext;

class ObjectTypeElementSeparatorContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_objectTypeElementSeparator;
    }

	COMMA() {
	    return this.getToken(graphParser.COMMA, 0);
	};

	SEMICOLON() {
	    return this.getToken(graphParser.SEMICOLON, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterObjectTypeElementSeparator(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitObjectTypeElementSeparator(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitObjectTypeElementSeparator(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class NonNullableTypeContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_nonNullableType;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class PredefinedTypeRefContext extends NonNullableTypeContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	predefinedType() {
	    return this.getTypedRuleContext(PredefinedTypeContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterPredefinedTypeRef(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitPredefinedTypeRef(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitPredefinedTypeRef(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.PredefinedTypeRefContext = PredefinedTypeRefContext;

class ArrayTypeContext extends NonNullableTypeContext {

    constructor(parser, ctx) {
        super(parser);
        this.nullable = null;;
        super.copyFrom(ctx);
    }

	nonNullableType() {
	    return this.getTypedRuleContext(NonNullableTypeContext,0);
	};

	LBRACKET() {
	    return this.getToken(graphParser.LBRACKET, 0);
	};

	RBRACKET() {
	    return this.getToken(graphParser.RBRACKET, 0);
	};

	QMARK() {
	    return this.getToken(graphParser.QMARK, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterArrayType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitArrayType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitArrayType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.ArrayTypeContext = ArrayTypeContext;

class StringLiteralTypeContext extends NonNullableTypeContext {

    constructor(parser, ctx) {
        super(parser);
        this.value = null;;
        super.copyFrom(ctx);
    }

	StringLiteral() {
	    return this.getToken(graphParser.StringLiteral, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterStringLiteralType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitStringLiteralType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitStringLiteralType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.StringLiteralTypeContext = StringLiteralTypeContext;

class TupleTypeContext extends NonNullableTypeContext {

    constructor(parser, ctx) {
        super(parser);
        this._type_ = null;;
        this.elementTypes = [];;
        super.copyFrom(ctx);
    }

	LBRACKET() {
	    return this.getToken(graphParser.LBRACKET, 0);
	};

	RBRACKET() {
	    return this.getToken(graphParser.RBRACKET, 0);
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.COMMA);
	    } else {
	        return this.getToken(graphParser.COMMA, i);
	    }
	};


	type_ = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(Type_Context);
	    } else {
	        return this.getTypedRuleContext(Type_Context,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTupleType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTupleType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTupleType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.TupleTypeContext = TupleTypeContext;

class TypeReferenceContext extends NonNullableTypeContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	typeAlias() {
	    return this.getTypedRuleContext(TypeAliasContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTypeReference(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTypeReference(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTypeReference(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.TypeReferenceContext = TypeReferenceContext;

class AngleUnionTypeContext extends NonNullableTypeContext {

    constructor(parser, ctx) {
        super(parser);
        this._type_ = null;;
        this.types = [];;
        super.copyFrom(ctx);
    }

	LANGLE() {
	    return this.getToken(graphParser.LANGLE, 0);
	};

	RANGLE() {
	    return this.getToken(graphParser.RANGLE, 0);
	};

	TypeOr = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(graphParser.TypeOr);
	    } else {
	        return this.getToken(graphParser.TypeOr, i);
	    }
	};


	type_ = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(Type_Context);
	    } else {
	        return this.getTypedRuleContext(Type_Context,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterAngleUnionType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitAngleUnionType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitAngleUnionType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.AngleUnionTypeContext = AngleUnionTypeContext;

class ParenthesisedTypeContext extends NonNullableTypeContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	LPAREN() {
	    return this.getToken(graphParser.LPAREN, 0);
	};

	type_() {
	    return this.getTypedRuleContext(Type_Context,0);
	};

	RPAREN() {
	    return this.getToken(graphParser.RPAREN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterParenthesisedType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitParenthesisedType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitParenthesisedType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.ParenthesisedTypeContext = ParenthesisedTypeContext;

class ObjectTypeContext extends NonNullableTypeContext {

    constructor(parser, ctx) {
        super(parser);
        this._propertySignature = null;;
        this.properties = [];;
        super.copyFrom(ctx);
    }

	LCURL() {
	    return this.getToken(graphParser.LCURL, 0);
	};

	RCURL() {
	    return this.getToken(graphParser.RCURL, 0);
	};

	objectTypeElementSeparator = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ObjectTypeElementSeparatorContext);
	    } else {
	        return this.getTypedRuleContext(ObjectTypeElementSeparatorContext,i);
	    }
	};

	indexSignature() {
	    return this.getTypedRuleContext(IndexSignatureContext,0);
	};

	propertySignature = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(PropertySignatureContext);
	    } else {
	        return this.getTypedRuleContext(PropertySignatureContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterObjectType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitObjectType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitObjectType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.ObjectTypeContext = ObjectTypeContext;

class PredefinedTypeContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_predefinedType;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class NumberTypeContext extends PredefinedTypeContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	Number() {
	    return this.getToken(graphParser.Number, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterNumberType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitNumberType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitNumberType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.NumberTypeContext = NumberTypeContext;

class BooleanTypeContext extends PredefinedTypeContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	Boolean() {
	    return this.getToken(graphParser.Boolean, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterBooleanType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitBooleanType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitBooleanType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.BooleanTypeContext = BooleanTypeContext;

class StringTypeContext extends PredefinedTypeContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	String() {
	    return this.getToken(graphParser.String, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterStringType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitStringType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitStringType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.StringTypeContext = StringTypeContext;

class EmptyTypeContext extends PredefinedTypeContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	Empty() {
	    return this.getToken(graphParser.Empty, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterEmptyType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitEmptyType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitEmptyType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.EmptyTypeContext = EmptyTypeContext;

class UnknownTypeContext extends PredefinedTypeContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	Unknown() {
	    return this.getToken(graphParser.Unknown, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterUnknownType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitUnknownType(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitUnknownType(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

graphParser.UnknownTypeContext = UnknownTypeContext;

class PropertySignatureContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_propertySignature;
    }

	propertyName() {
	    return this.getTypedRuleContext(PropertyNameContext,0);
	};

	typeAnnotation() {
	    return this.getTypedRuleContext(TypeAnnotationContext,0);
	};

	QMARK() {
	    return this.getToken(graphParser.QMARK, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterPropertySignature(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitPropertySignature(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitPropertySignature(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class IndexSignatureContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_indexSignature;
    }

	LBRACKET() {
	    return this.getToken(graphParser.LBRACKET, 0);
	};

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	String() {
	    return this.getToken(graphParser.String, 0);
	};

	RBRACKET() {
	    return this.getToken(graphParser.RBRACKET, 0);
	};

	typeAnnotation() {
	    return this.getTypedRuleContext(TypeAnnotationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterIndexSignature(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitIndexSignature(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitIndexSignature(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TypeAnnotationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_typeAnnotation;
    }

	COLON() {
	    return this.getToken(graphParser.COLON, 0);
	};

	type_() {
	    return this.getTypedRuleContext(Type_Context,0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTypeAnnotation(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTypeAnnotation(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTypeAnnotation(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class TypeAliasContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = graphParser.RULE_typeAlias;
    }

	ID() {
	    return this.getToken(graphParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.enterTypeAlias(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof graphListener ) {
	        listener.exitTypeAlias(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof graphVisitor ) {
	        return visitor.visitTypeAlias(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}




graphParser.FileContext = FileContext; 
graphParser.ReferenceFileContext = ReferenceFileContext; 
graphParser.ExpressionFileContext = ExpressionFileContext; 
graphParser.BlockContentContext = BlockContentContext; 
graphParser.SystemDescriptionContext = SystemDescriptionContext; 
graphParser.SystemElementDescriptionContext = SystemElementDescriptionContext; 
graphParser.ContextDescriptionContext = ContextDescriptionContext; 
graphParser.ContextElementDescriptionContext = ContextElementDescriptionContext; 
graphParser.ExternalFunctionDeclarationContext = ExternalFunctionDeclarationContext; 
graphParser.ImportDefinitionContext = ImportDefinitionContext; 
graphParser.WhenDescriptionContext = WhenDescriptionContext; 
graphParser.TypeDefinitionContext = TypeDefinitionContext; 
graphParser.FunctionDescriptionContext = FunctionDescriptionContext; 
graphParser.ContextFunctionDescriptionContext = ContextFunctionDescriptionContext; 
graphParser.BlockDeclarationContext = BlockDeclarationContext; 
graphParser.NodeDeclarationContext = NodeDeclarationContext; 
graphParser.DigressionDeclarationContext = DigressionDeclarationContext; 
graphParser.DigressionContentContext = DigressionContentContext; 
graphParser.CommentContext = CommentContext; 
graphParser.NodeContentContext = NodeContentContext; 
graphParser.NodeOnExitSectionContext = NodeOnExitSectionContext; 
graphParser.NodeOnExitSectionItemContext = NodeOnExitSectionItemContext; 
graphParser.OnExitDoWithConfidentContext = OnExitDoWithConfidentContext; 
graphParser.NodeOnDigressionReturnSectionContext = NodeOnDigressionReturnSectionContext; 
graphParser.NodeTransitionSectionContext = NodeTransitionSectionContext; 
graphParser.NamedTransitionDefinitionContext = NamedTransitionDefinitionContext; 
graphParser.TransitionDefinitionContext = TransitionDefinitionContext; 
graphParser.TransitionDefinitionOnMessageContext = TransitionDefinitionOnMessageContext; 
graphParser.TimeoutTransitionDefinitionContext = TimeoutTransitionDefinitionContext; 
graphParser.ConditionalTransitionDefinitionContext = ConditionalTransitionDefinitionContext; 
graphParser.UnconditionalTransitionDefinitionContext = UnconditionalTransitionDefinitionContext; 
graphParser.DoSectionContext = DoSectionContext; 
graphParser.BlockBodyContext = BlockBodyContext; 
graphParser.OneOrGroupedCommandContext = OneOrGroupedCommandContext; 
graphParser.NodeCommandContext = NodeCommandContext; 
graphParser.CycleCommandContext = CycleCommandContext; 
graphParser.StatementContext = StatementContext; 
graphParser.StatementBodyContext = StatementBodyContext; 
graphParser.LogExpressionTypeCommandContext = LogExpressionTypeCommandContext; 
graphParser.DigressionControlContext = DigressionControlContext; 
graphParser.DigressionSpecContext = DigressionSpecContext; 
graphParser.ExitCommandContext = ExitCommandContext; 
graphParser.ReturnCommandContext = ReturnCommandContext; 
graphParser.VariableDefinitionContext = VariableDefinitionContext; 
graphParser.VariableDeclarationContext = VariableDeclarationContext; 
graphParser.TypeDescriptionContext = TypeDescriptionContext; 
graphParser.ConditionalCommandContext = ConditionalCommandContext; 
graphParser.ForeachCommandContext = ForeachCommandContext; 
graphParser.WaitCommandContext = WaitCommandContext; 
graphParser.ActivatedTransitionListContext = ActivatedTransitionListContext; 
graphParser.GotoCommandContext = GotoCommandContext; 
graphParser.SetCommandContext = SetCommandContext; 
graphParser.AssignOpCommandContext = AssignOpCommandContext; 
graphParser.LValueContext = LValueContext; 
graphParser.ExpressionContext = ExpressionContext; 
graphParser.ObjectPropertyExpressionPartContext = ObjectPropertyExpressionPartContext; 
graphParser.ExternalFunctionCallContext = ExternalFunctionCallContext; 
graphParser.BlockFunctionCallContext = BlockFunctionCallContext; 
graphParser.SlotFillingCallContext = SlotFillingCallContext; 
graphParser.BuiltinFunctionCallContext = BuiltinFunctionCallContext; 
graphParser.ArgumentInvokationContext = ArgumentInvokationContext; 
graphParser.ArgumentListContext = ArgumentListContext; 
graphParser.NamedArgumentListContext = NamedArgumentListContext; 
graphParser.PositionalArgumentListContext = PositionalArgumentListContext; 
graphParser.PositionalArgumentContext = PositionalArgumentContext; 
graphParser.NamedArgumentContext = NamedArgumentContext; 
graphParser.ParameterListContext = ParameterListContext; 
graphParser.ParameterContext = ParameterContext; 
graphParser.ReferenceContext = ReferenceContext; 
graphParser.WhenIdContext = WhenIdContext; 
graphParser.NodeIdContext = NodeIdContext; 
graphParser.BlockIdContext = BlockIdContext; 
graphParser.DigressionIdContext = DigressionIdContext; 
graphParser.TransitionNameContext = TransitionNameContext; 
graphParser.ReferenceNameContext = ReferenceNameContext; 
graphParser.MemberNameContext = MemberNameContext; 
graphParser.TagNameContext = TagNameContext; 
graphParser.FactNameContext = FactNameContext; 
graphParser.FieldNameContext = FieldNameContext; 
graphParser.VariableNameContext = VariableNameContext; 
graphParser.ArgumentNameContext = ArgumentNameContext; 
graphParser.ParameterNameContext = ParameterNameContext; 
graphParser.PropertyNameContext = PropertyNameContext; 
graphParser.BuiltinFunctionNameContext = BuiltinFunctionNameContext; 
graphParser.ExternalFunctionNameContext = ExternalFunctionNameContext; 
graphParser.FunctionNameContext = FunctionNameContext; 
graphParser.AnyNumberContext = AnyNumberContext; 
graphParser.TypeEofContext = TypeEofContext; 
graphParser.Type_Context = Type_Context; 
graphParser.QuestionMarkOptionalContext = QuestionMarkOptionalContext; 
graphParser.ObjectTypeElementSeparatorContext = ObjectTypeElementSeparatorContext; 
graphParser.NonNullableTypeContext = NonNullableTypeContext; 
graphParser.PredefinedTypeContext = PredefinedTypeContext; 
graphParser.PropertySignatureContext = PropertySignatureContext; 
graphParser.IndexSignatureContext = IndexSignatureContext; 
graphParser.TypeAnnotationContext = TypeAnnotationContext; 
graphParser.TypeAliasContext = TypeAliasContext; 
